<template>
  <v-layout align-start>
    <v-flex>
      <v-data-table
        :headers="headers"
        :items="viaje"
        :search="search"
        :single-expand="true"
        :expanded.sync="expanded"
        sort-by="nombre"
        class="elevation-1"
        show-expand
        style="background: rgba(255, 255, 255, 0.7)"
      >
        <template #item.nro="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on">{{ item.nro }}</span>
            </template>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th colspan="2">DETALLES</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="py-n5">
                    <td class="text-caption">COMISIONADO</td>
                    <td class="text-caption">
                      {{ item.comisionado_comisionado.usuario_usuario.nombre }}
                    </td>
                  </tr>
                  <tr class="py-n5">
                    <td class="text-caption">MOTIVO VIAJE</td>
                    <td class="text-caption">
                      {{ item.motivo }}
                    </td>
                  </tr>
                  <tr class="py-n5">
                    <td class="text-caption">CONEXION</td>
                    <td class="text-caption">
                      {{ item.ruta_viaje }}
                    </td>
                  </tr>
                  <tr class="py-n5">
                    <td class="text-caption">FINANCIAMIENTO</td>
                    <td class="text-caption">
                      {{ item.financiamiento_financiamiento.nombre }}
                    </td>
                  </tr>
                  <tr class="py-n5">
                    <td class="text-caption">TIPO VIAJE</td>
                    <td class="text-caption">
                      {{
                        item.viaje_nacionals[0].region_nacional_region_nacional
                          .nombre
                      }}
                    </td>
                  </tr>
                  <tr class="py-n5">
                    <td class="text-caption">RESOLUCION</td>
                    <td class="text-caption">
                      {{ item.resolucion_resolucion.descripcion }}
                    </td>
                  </tr>
                  <tr class="py-n5">
                    <td class="text-caption">FIN DE SEMANA</td>
                    <td class="text-caption">
                      {{ item.fines_semana }}
                    </td>
                  </tr>
                  <tr class="py-n5">
                    <td class="text-caption">PROGRAMA</td>
                    <td class="text-caption">
                      {{
                        item.comisionado_comisionado.usuario_usuario
                          .oficina_oficina.nombre
                      }}
                    </td>
                  </tr>
                  <tr class="py-1">
                    <td class="text-caption">TRANSPORTE</td>
                    <td class="text-caption">
                      {{ item.transporte_transporte.nombre }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-tooltip>
        </template>
        <template #item.total_viatico="{ item }">
          {{
            new Intl.NumberFormat("es-BO", { minimumFractionDigits: 2 }).format(
              item.total_viatico,
            )
          }}
        </template>
        <template #item.tpasaje="{ item }">
          {{
            new Intl.NumberFormat("es-BO", { minimumFractionDigits: 2 }).format(
              item.tpasaje,
            )
          }}
        </template>
        <template #item.fecha1="{ item }">
          {{
            item.fecha1
            /* new Date(
              item.fecha1.split(" ")[0].split("/").reverse().join("-")
            ).toLocaleDateString("en-GB") +
            " " +
            item.fecha1.split(" ")[1] */
          }}
        </template>
        <template #item.fecha2="{ item }">
          {{
            item.fecha2
            /* new Date(
              item.fecha2.split(" ")[0].split("/").reverse().join("-")
            ).toLocaleDateString("en-GB") +
            " " +
            item.fecha2.split(" ")[1] */
          }}
        </template>
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>PRESUPUESTO VIAJES</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-autocomplete
              v-model="unidadModel"
              :items="unidad"
              @change="(valor) => changeUnidad(valor)"
              label="Unidad"
              v-if="isAdmin"
            ></v-autocomplete>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Buscar...."
              single-line
              hide-details
            >
            </v-text-field>
            <v-spacer></v-spacer>
            <!-- <v-btn depressed color="primary" @click="listTicket">
              <v-icon left dark fab large> airplane_ticket </v-icon>
              Pasaje Aereo
            </v-btn> -->
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-dialog v-model="dialog" max-width="850px">
                <ViajeForm
                  :value="editedItem"
                  :paises="pais"
                  :departamentos="departamentos"
                  :unidades="unidad"
                  :resoluciones="resolucion"
                  :regionesNacionales="rn"
                  :regionesInternacionales="ri"
                  :transportes="transporte"
                  :financiamientos="financiamientos"
                  :showLugar="showLugar"
                  :showCheck="showCheck"
                  :isEdit="editedIndex > -1"
                  @save="onSaveViaje"
                  @cancel="close"
                  @change-pais="changeState"
                  @change-lugar="changeState2"
                  @change-tipo="changeTipo"
                />
              </v-dialog>
            </v-form>
            <v-form ref="form2" v-model="valid2" lazy-validation>
              <v-dialog v-model="dialog2" max-width="800px">
                <PresupuestoForm
                  :value="editedItem2"
                  :isEdit="editedIndex2 > -1"
                  :lineasAereas="linea"
                  @save="onSavePresupuesto"
                  @cancel="presupClose"
                  v-slot:extra-fields="slotProps"
                >
                  <!-- Aquí puedes incluir los campos dinámicos de pasajes terrestres y aéreos si lo deseas -->
                </PresupuestoForm>
              </v-dialog>
            </v-form>
            <DialogConfirm
              v-model="dialogCancel"
              title="¿Esta seguro de Anular el viaje?"
              confirmText="Aceptar"
              cancelText="Cancelar"
              confirmColor="blue darken-1"
              cancelColor="red darken-1"
              @confirm="cancelViajeConfirm"
              @cancel="closeCancelViaje"
            >
              <v-textarea v-model="motivo" auto-grow label="Motivo" rows="1" />
            </DialogConfirm>
            <DialogConfirm
              v-model="dialog4"
              title="Cambiar Fecha"
              confirmText="Guardar"
              cancelText="Cancelar"
              confirmColor="blue darken-1"
              cancelColor="blue darken-1"
              @confirm="crearPDF(solPdf)"
              @cancel="closeCamFecha"
            >
              <v-container>
                <v-row>
                  <v-col cols="12" lg="6">
                    <v-menu
                      ref="menu5"
                      v-model="menu5"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="date"
                          label="Date"
                          persistent-hint
                          prepend-icon="mdi-calendar"
                          v-bind="attrs"
                          v-on="on"
                        />
                      </template>
                      <v-date-picker
                        v-model="date"
                        no-title
                        @input="menu5 = false"
                      />
                    </v-menu>
                  </v-col>
                </v-row>
              </v-container>
            </DialogConfirm>
            <!---------------------------------------------------------------------------------------->
            <!-------------MODAL DE LIQUIDACION------------------------------------------------------->

            <v-form ref="form3" v-model="valid3" lazy-validation>
              <v-dialog v-model="dialog3" max-width="900px">
                <LiquidacionForm
                  :value="editedItem3"
                  :paises="pais"
                  :isEdit="editedIndex3 > -1"
                  @save="onSaveLiquidacion"
                  @cancel="close1"
                  v-slot:extra-fields="slotProps"
                >
                  <v-row class="py-md-0 my-md-n7">
                    <v-col cols="12" sm="4" md="3">
                      <v-subheader>Ruta de Viaje</v-subheader>
                    </v-col>
                    <v-col cols="12" sm="8" md="9">
                      <v-text-field
                        v-model="editedItem3.ruta_viajeLi"
                        solo
                        readonly
                        required
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row class="py-md-0 my-md-n7">
                    <v-col cols="12" sm="4" md="3">
                      <v-subheader>Resolucion</v-subheader>
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                      <v-select
                        v-model="editedItem3.resolucionLi"
                        :items="resolucion"
                        solo
                        readonly
                        required
                      >
                      </v-select>
                    </v-col>
                  </v-row>
                  <v-row class="py-md-0 my-md-n7">
                    <v-col cols="12" sm="4" md="3">
                      <v-subheader>Programa-Transporte</v-subheader>
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                      <v-select
                        v-model="editedItem3.idunidadLi"
                        :items="unidad"
                        :rules="[(v) => !!v || 'Unidad es Requerido']"
                        solo
                        readonly
                        required
                      >
                      </v-select>
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                      <v-select
                        v-model="editedItem3.transporteLi"
                        :items="transporte"
                        solo
                        readonly
                        required
                      >
                      </v-select>
                    </v-col>
                  </v-row>
                  <v-row class="py-md-0 my-md-n7">
                    <v-col cols="12" sm="4" md="3">
                      <v-subheader>¿Menor a 100 Km?</v-subheader>
                    </v-col>
                    <v-checkbox
                      v-model="editedItem3.distanciaLi"
                      solo
                      readonly
                      required
                    >
                    </v-checkbox>
                  </v-row>
                  <v-row class="py-md-0 my-md-n7">
                    <v-col cols="12" sm="4" md="3">
                      <v-subheader>Viaje-Financiamiento</v-subheader>
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                      <v-text-field
                        v-model="editedItem3.tvLi"
                        label="Tipo de Viaje"
                        solo
                        readonly
                        required
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                      <v-select
                        v-model="editedItem3.financiamientoLi"
                        :items="financiamientos"
                        :rules="[(v) => !!v || 'Financiamiento es Requerido']"
                        solo
                        readonly
                        required
                      >
                      </v-select>
                    </v-col>
                  </v-row>
                  <v-row class="py-md-0 my-md-n7">
                    <v-col cols="12" sm="4" md="3">
                      <v-subheader>Periodo de Comision</v-subheader>
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                      <v-text-field
                        v-model="editedItem3.fecha1li"
                        solo
                        readonly
                        required
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                      <v-text-field
                        v-model="editedItem3.fecha2li"
                        solo
                        readonly
                        required
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row class="py-md-0 my-md-n7">
                    <v-col cols="12" sm="4" md="3">
                      <v-subheader
                        >Costo de Pasajes (Aereo/Terrestre)
                      </v-subheader>
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                      <v-text-field
                        v-model="editedItem3.pasAereoLi"
                        solo
                        :disabled="showaereo"
                        required
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                      <v-text-field
                        v-model="editedItem3.pasTerrestreLi"
                        solo
                        :disabled="showterrestre"
                        required
                        value="Factura"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row class="py-md-0 my-md-n7">
                    <v-col cols="12" sm="4" md="3">
                      <v-subheader>Viático</v-subheader>
                    </v-col>

                    <v-radio-group
                      v-model="editedItem3.anticipo"
                      :rules="[(v) => !!v || 'Seleccion Requerida']"
                      label=""
                      row
                      required
                    >
                      <v-radio label="Reembolso" value="NO"></v-radio>
                      <v-radio label="Anticipo" value="SI"></v-radio>
                    </v-radio-group>
                    <!--                         <v-radio-group
                          v-model="editedItem3.facturacionterres"
                          :rules="[(v) => !!v || 'Seleccion Requerida']"
                          label=""
                          row
                          required
                          @change="(valor) => changetipote(valor)"
                        >
                          <v-radio
                            label="Reembolso"
                            value="reembolso"
                          ></v-radio>
                          <v-radio label="Anticipo" value="anticipo"></v-radio>
                        </v-radio-group> -->
                  </v-row>
                  <v-row class="py-md-0 my-md-n7">
                    <v-col cols="12" sm="4" md="3">
                      <v-subheader>Recomendaciones Observaciones</v-subheader>
                    </v-col>
                    <v-col cols="12" sm="8" md="8">
                      <v-text-field
                        v-model="editedItem3.observaciones"
                        label="Observaciones"
                        required
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <!-- Aquí puedes incluir campos adicionales si lo deseas -->
                </LiquidacionForm>
              </v-dialog>
            </v-form>
          </v-toolbar>

          <!--------------------------------------------------------------------------------------------------->
          <!--------------------------------------------------------------------------------------------------->
        </template>
        <template v-slot:item.actions="{ item }">
          <div class="text-truncate">
            <v-tooltip
              bottom
              v-if="item.estado_estado.id > 2 && rol == 'ROLE_ADMIN'"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  icon
                  class="mr-2"
                  @click="editItem(item)"
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mode_edit </v-icon>
                </v-btn>
              </template>
              <span>Editar Viaje</span>
            </v-tooltip>
            <v-tooltip
              bottom
              v-if="item.estado_estado.id == 1 || item.estado_estado.id == 2"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  icon
                  class="mr-2"
                  @click="editItem(item)"
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mode_edit</v-icon>
                </v-btn>
              </template>
              <span>Editar Viaje</span>
            </v-tooltip>
            <v-tooltip bottom v-if="item.estado_estado.id == 1">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  icon
                  class="mr-2"
                  @click="presupEdit(item)"
                  color="accent"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>sell</v-icon>
                </v-btn>
              </template>
              <span>Presupuestar</span>
            </v-tooltip>
            <v-tooltip bottom v-if="item.estado_estado.id <= 5">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  icon
                  class="mr-2"
                  @click="camFecha(item)"
                  color="secondary"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>print</v-icon>
                </v-btn>
              </template>
              <span>Imprimir Solicitud</span>
            </v-tooltip>
            <v-tooltip
              bottom
              v-if="
                item.estado_estado.id == 2 ||
                (item.estado_estado.id == 3 && item.transporte != 3)
              "
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  icon
                  class="mr-2"
                  @click="presupEdit2(item)"
                  color="success"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>sell </v-icon>
                </v-btn>
              </template>
              <span>Editar Presupuesto</span>
            </v-tooltip>
            <v-tooltip
              bottom
              v-if="item.estado_estado.id > 3 && rol == 'ROLE_ADMIN'"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  icon
                  class="mr-2"
                  @click="presupEdit2(item)"
                  color="success"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>sell </v-icon>
                </v-btn>
              </template>
              <span>Editar Presupuesto</span>
            </v-tooltip>
            <v-tooltip
              bottom
              v-if="item.estado_estado.id == 3 || item.estado_estado.id == 4"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  icon
                  class="mr-2"
                  @click="editItem1(item)"
                  color="accent"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>request_quote</v-icon>
                </v-btn>
              </template>
              <span>Liquidar</span>
            </v-tooltip>
            <v-tooltip
              bottom
              v-if="item.estado_estado.id == 1 || item.estado_estado.id == 2"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  icon
                  class="mr-2"
                  @click="cancelViaje(item)"
                  color="error"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>do_disturb_alt</v-icon>
                </v-btn>
              </template>
              <span>Cancelar Viaje</span>
            </v-tooltip>
            <v-tooltip bottom v-if="item.estado_estado.id >= 2">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  icon
                  class="mr-2"
                  @click="crearPresupPDF(item)"
                  color="secondary"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>print</v-icon>
                </v-btn>
              </template>
              <span>Imprimir Presupuesto</span>
            </v-tooltip>
            <v-tooltip
              bottom
              v-if="
                item.estado_estado.id == 2 &&
                rol == 'ROLE_ADMIN' &&
                new Date() >
                  new Date(item.fecha_informe.split('/').reverse().join('-'))
              "
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  icon
                  class="mr-2"
                  @click="changeEdit(item)"
                  color="accent"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>edit_document</v-icon>
                </v-btn>
              </template>
              <span>Habilitar subir informe</span>
            </v-tooltip>
            <v-tooltip bottom v-if="item.estado_estado.id == 4">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  icon
                  class="mr-2"
                  @click="crearLiquiPDF(item)"
                  color="secondary"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>local_printshop</v-icon>
                </v-btn>
              </template>
              <span>Imprimir Liquidación</span>
            </v-tooltip>
            <v-tooltip
              bottom
              v-if="item.estado_estado.id == 3 || item.estado_estado.id == 4"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  icon
                  class="mr-2"
                  @click="bajarPDF(item)"
                  color="info"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>picture_as_pdf</v-icon>
                </v-btn>
              </template>
              <span>Descargar Informe</span>
            </v-tooltip>
            <v-tooltip bottom v-if="item.estado_estado.id == 3">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  icon
                  class="mr-2"
                  @click="rechazar(item)"
                  color="error"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>clear</v-icon>
                </v-btn>
              </template>
              <span>Rechazar Informe</span>
            </v-tooltip>
          </div>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="viajeList()"> Refrescar </v-btn>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">
            <div v-if="item.expanded">
              <v-data-table
                :headers="headers2"
                :items="item.pasajes"
                :disable-pagination="true"
                class="mx-16"
                hide-default-footer
              >
                <template #item.pas_aereo="{ item }">
                  {{
                    new Intl.NumberFormat("es-BO", {
                      minimumFractionDigits: 2,
                    }).format(item.pas_aereo)
                  }}
                </template>
                <template v-slot:item.actions="{ item }">
                  <div class="text-truncate" v-if="item.expanded">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          small
                          icon
                          class="mr-2"
                          @click="liberar(item)"
                          color="primary"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon>airplane_ticket</v-icon>
                        </v-btn>
                      </template>
                      <span>Liberar</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          small
                          icon
                          class="mr-2"
                          @click="anular(item)"
                          color="error"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon>no_sim</v-icon>
                        </v-btn>
                      </template>
                      <span>Anular</span>
                    </v-tooltip>
                  </div>
                </template>
                <template v-slot:no-data>
                  <h6>No se encuentra en presupuesto</h6>
                </template>
                <template v-slot:body.append>
                  <tr>
                    <td class="text-right" colspan="2">Total:</td>
                    <td class="text-right">
                      {{
                        new Intl.NumberFormat("es-BO", {
                          minimumFractionDigits: 2,
                        }).format(sumField("pas_aereo", item.pasajes))
                      }}
                    </td>
                    <td></td>
                  </tr>
                </template>
              </v-data-table>
            </div>
            <v-data-table
              :headers="headers2"
              :items="item.pasajes"
              :disable-pagination="true"
              class="mx-16"
              hide-default-footer
            >
              <template #item.pas_aereo="{ item }">
                {{
                  new Intl.NumberFormat("es-BO", {
                    minimumFractionDigits: 2,
                  }).format(item.pas_aereo)
                }}
              </template>
              <template v-slot:item.actions="{ item }">
                <div class="text-truncate">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        small
                        icon
                        class="mr-2"
                        @click="liberar(item)"
                        color="primary"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon>airplane_ticket</v-icon>
                      </v-btn>
                    </template>
                    <span>Liberar</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        small
                        icon
                        class="mr-2"
                        @click="anular(item)"
                        color="error"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon>no_sim</v-icon>
                      </v-btn>
                    </template>
                    <span>Anular</span>
                  </v-tooltip>
                </div>
              </template>
              <template v-slot:no-data>
                <h6>No se encuentra en presupuesto</h6>
              </template>
              <template v-slot:body.append>
                <tr>
                  <td class="text-right" colspan="2">Total:</td>
                  <td class="text-right">
                    {{
                      new Intl.NumberFormat("es-BO", {
                        minimumFractionDigits: 2,
                      }).format(sumField("pas_aereo", item.pasajes))
                    }}
                  </td>
                  <td></td>
                </tr>
              </template>
            </v-data-table>
          </td>
        </template>
      </v-data-table>
      <v-snackbar
        v-model="snackbar"
        :timeout="2200"
        bottom
        centered
        rounded="pill"
        :color="color"
        elevation="12"
      >
        <template>
          {{ message }}
        </template>
      </v-snackbar>
      <v-dialog v-model="pdfDialog" max-width="1200px">
        <v-card>
          <v-card-title>
            <span class="headline">{{ titlePDF }} </span>
            <v-spacer></v-spacer>
            <v-btn icon color="secondary" @click="closePdfDialog">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <iframe
              v-if="pdfUrl"
              :src="pdfUrl"
              width="100%"
              height="600px"
              style="border: none"
            ></iframe>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import QRCode from "qrcode";
import "../assets/fonts/verdana-normal.js";
import ViajeForm from "./ViajeForm.vue";
import PresupuestoForm from "./PresupuestoForm.vue";
import LiquidacionForm from "./LiquidacionForm.vue";
import ViajeTable from "./ViajeTable.vue";
import PasajeTable from "./PasajeTable.vue";
import DialogConfirm from "./DialogConfirm.vue";
import {
  addViaje,
  updateViaje,
  addPresupuesto,
  updatePresupuesto,
  addLiquidacion,
  getPaises,
  getDepartamentos,
  getTransporte,
  getUnidad,
  getFinanciamiento,
  getRegionNacional,
  getRegionInternacional,
  getLineaAerea,
  getResolucion,
  getUsuario,
  getViajesPorUnidad,
  downloadArchivo,
} from "../api/viajes";

const logo = require("@/assets/logoCab.jpg");
const logo2 = require("@/assets/membrete.png");
export default {
  components: {
    ViajeForm,
    PresupuestoForm,
    LiquidacionForm,
    ViajeTable,
    PasajeTable,
    DialogConfirm,
    // ... otros componentes si los hay
  },
  data() {
    return {
      dialog: false,
      dialogCancel: false,
      dialogTicket: false,
      valid: false,
      rol: "",
      pdfDialog: false,
      pdfUrl: "",
      dialog2: false,
      dialog3: false,
      dialog4: false,
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substring(0, 10),
      valid2: false,
      valid3: false,
      solPdf: {},
      showLugar: false,
      showCheck: false,
      search: "",
      message: "",
      color: "",
      snackbar: false,
      titlePDF: "",
      dateNow: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substring(0, 10),
      timeNow: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substring(11, 5),
      menu: "",
      menu2: "",
      menu3: "",
      menu4: "",
      menu5: "",
      menuli: "",
      menu2li: "",
      menu3li: "",
      menu4li: "",
      motivo: "",
      model: 1,
      showaereo: "",
      showterrestre: "", //showfacte:"",
      //showfacaer:"",
      swtr: false,
      swtrAereo: false,
      swBol: false,
      viaje: [],
      checkbox: false,
      departamentos: [],
      pais: [],
      categoria: "",
      transporte: [],
      unidad: [],
      financiamientos: [],
      presupuesto: [],
      expanded: [],
      ri: [],
      rn: [],
      linea: [],
      boletos: [],
      reuBoleto: [],
      resolucion: [],
      unidadModel: "",
      headers: [
        { text: "Nro°", value: "nro", sortable: false, width: "7%" },
        { text: "Pais", value: "pais_pai.nombre", sortable: false },
        {
          text: "Funcionario",
          value: "comisionado_comisionado.usuario_usuario.nombre",
        },
        {
          text: "Departamento",
          value: "iddepto_departamento.departamento",
          sortable: false,
        },
        { text: "Lugar", value: "lugar", sortable: false },
        { text: "Ida", value: "fecha1", sortable: false },
        { text: "Retorno", value: "fecha2", sortable: false },
        {
          text: "Viaticos",
          value: "total_viatico",
          sortable: false,
          align: "end",
        },
        { text: "Pasajes", value: "tpasaje", sortable: false, align: "end" },
        { text: "Dias", value: "dias", sortable: false },
        { text: "Estado", value: "estado_estado.nombre", sortable: false },
        {
          text: "Opciones",
          value: "actions",
          align: "center",
          width: "10%",
          sortable: false,
        },
      ],
      headers2: [
        { text: "Linea Aerea", value: "aereo.linea_aerea" },
        { text: "Codigo", value: "numero_boleto" },
        {
          text: "Costo Boleto",
          value: "pas_aereo",
          align: "right",
          width: "140",
        },
        {
          text: "Opciones",
          value: "actions",
          align: "center",
          width: "10%",
          sortable: false,
        },
      ],
      editedIndex: -1,
      editedIndex2: -1,
      editedIndex3: -1,
      editedItem: {
        anticipo: null,
        cite: null,
        comisionado: null,
        cot_dolar: null,
        dias: null,
        estado: null,
        fecha1: null,
        fecha2: null,
        fecha_informe: null,
        fecha_reliquidado: null,
        financiamiento: null,
        fines_semana: null,
        fuente_financiamiento: null,
        id: null,
        iddepto: null,
        idpresupuesto: null,
        idunidad: null,
        iva: null,
        lugar: null,
        motivo: null,
        pais: null,
        pais_pai: null,
        representacion: null,
        resolucion: null,
        ruta_viaje: null,
        slug: null,
        total_viatico: null,
        transporte: null,
        viatico: null,
        date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substring(0, 10),
        date2: null,
        time: null,
        time2: null,
        tv: "",
        distancia: false,
        radioRow: "",
        radioPoa: "",
      },
      defaultItem: {
        anticipo: null,
        cite: null,
        comisionado: null,
        cot_dolar: null,
        dias: null,
        estado: null,
        fecha1: null,
        fecha2: null,
        fecha_informe: null,
        fecha_reliquidado: null,
        financiamiento: null,
        fines_semana: null,
        fuente_financiamiento: null,
        id: null,
        iddepto: null,
        idpresupuesto: null,
        idunidad: null,
        iva: null,
        lugar: null,
        motivo: null,
        pais: null,
        pais_pai: null,
        representacion: null,
        resolucion: null,
        ruta_viaje: null,
        slug: null,
        total_viatico: null,
        transporte: null,
        viatico: null,
        date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substring(0, 10),
        date2: null,
        time: null,
        time2: null,
        tv: "",
        distancia: false,
        radioRow: "",
        radioPoa: "",
        facturacion: "",
      },
      editedItem2: {
        id: "",
        cite: "",
        unidad: "",
        periodoIda: "",
        periodoVuelta: "",
        viatico: "",
        financiamiento: "",
        pasaje: "",
        salViatico: "",
        pasTerrestre: 0,
        boletoAereo: [
          {
            id: null,
            reBoleto: null,
            lineaAerea: null,
            pasAereo: null,
          },
        ],
        delboletoAereo: [],
        pasajeTerr: [
          {
            id: null,
            pasaje: null,
            factura: null,
          },
        ],
        delpasajeTerr: [],
        aux: 0,
        auxBoleto: "",
      },
      defaultItem2: {
        id: "",
        cite: "",
        unidad: "",
        periodoIda: "",
        periodoVuelta: "",
        viatico: "",
        financiamiento: "",
        pasaje: "",
        salViatico: "",
        pasTerrestre: "",
        boletoAereo: [
          {
            id: null,
            reBoleto: null,
            lineaAerea: null,
            pasAereo: null,
          },
        ],
        delboletoAereo: [],
        pasajeTerr: [
          {
            id: null,
            pasaje: null,
            factura: null,
          },
        ],
        delpasajeTerr: [],
        aux: 0,
        auxBoleto: "",
      },
      editedItem3: {
        id: "",
        anticipo: "NO",
        motivoViaje: "",
        paisComision: "",
        iddeptoComision: "",
        lugarli: "",
        ruta_viajeLi: "",
        resolucionLi: null,
        transporteLi: "",
        distanciaLi: "",
        idunidadLi: null,
        tvLi: "",
        financiamientoLi: "",
        pasAereoLi: "",
        pasTerrestreLi: "",
        boletosLi: "",
        fines_semana: null,
        fecha1li: "",
        fecha2li: "",
        fecha1: "",
        fecha2: "",
        num_factura: null,
        tazaAereoLi: "",
        fines_semanali: "",
        //cut_monto: null,
        //preventivo_c31: null,
        observaciones: null,
        //reembolso: "",
        //anticipo:null,
        //showanticipo:false,
        snackbar: false,
        estado: null,
        idviaje: "",
        idpasajes: "",
        //fecha2Li1:null
        saldo_viaticos: null,
        dateli: null,
        date2li: null,
        timeli: null,
        time2li: null,
        fecha_edita: null,
        descuento: null,
        recibo: null,
        facturacionaereo: null,
        num_facturaaereo: null,
        num_facturaterres: null,
        facturacionterres: null,
        descuento: 0.155,
      },
      defaultItem3: {
        id: "",
        anticipo: "NO",
        motivoViaje: "",
        paisComision: "",
        iddeptoComision: "",
        lugarli: "",
        ruta_viajeLi: "",
        resolucionLi: "",
        distanciaLi: "",
        idunidadLi: "",
        tvLi: "",
        boletosLi: "",
        financiamientoLi: "",
        fines_semanali: "",
        fecha1: "",
        fecha2: "",
        pasAereoLi: "",
        pasTerrestreLi: "",
        num_factura: null,
        tazaAereoLi: "",
        //cut_monto: null,
        //preventivo_c31: null,
        observaciones: null,
        //cut_comprobante: null,
        // reembolso: "",
        //anticipo:null,
        //showanticipo:false,
        snackbar: false,
        estado: null,
        idviaje: "",
        idpasajes: "",
        //fecha2Li1:null
        saldo_viaticos: null,
        dateli: "",
        date2li: "",
        timeli: "",
        time2li: "",
        dias: "",
        fecha_edita: "",
        descuento: "",
        facturacion: "",
      },
      actions: [
        {
          name: "edit",
          icon: "mode_edit",
          color: "primary",
          label: "Editar Viaje",
          event: "edit",
          show: (item) =>
            (item.estado_estado.id > 2 && this.rol == "ROLE_ADMIN") ||
            item.estado_estado.id == 1 ||
            item.estado_estado.id == 2,
        },
        {
          name: "presup",
          icon: "sell",
          color: "accent",
          label: "Presupuestar",
          event: "presup",
          show: (item) => item.estado_estado.id == 1,
        },
        {
          name: "imprimir",
          icon: "print",
          color: "secondary",
          label: "Imprimir Solicitud",
          event: "imprimir",
          show: (item) => item.estado_estado.id <= 4,
        },
        {
          name: "presupEdit",
          icon: "sell",
          color: "success",
          label: "Editar Presupuesto",
          event: "presupEdit",
          show: (item) =>
            item.estado_estado.id == 2 ||
            (item.estado_estado.id == 3 && item.transporte != 3) ||
            (item.estado_estado.id > 3 && this.rol == "ROLE_ADMIN"),
        },
        {
          name: "liquidar",
          icon: "request_quote",
          color: "accent",
          label: "Liquidar",
          event: "liquidar",
          show: (item) => item.estado_estado.id == 3,
        },
        {
          name: "cancelar",
          icon: "do_disturb_alt",
          color: "error",
          label: "Cancelar Viaje",
          event: "cancelar",
          show: (item) =>
            item.estado_estado.id == 1 || item.estado_estado.id == 2,
        },
        {
          name: "imprimirPresup",
          icon: "print",
          color: "secondary",
          label: "Imprimir Presupuesto",
          event: "imprimirPresup",
          show: (item) => item.estado_estado.id >= 2,
        },
        {
          name: "habilitarInforme",
          icon: "edit_document",
          color: "primary",
          label: "Habilitar subir informe",
          event: "habilitarInforme",
          show: (item) =>
            item.estado_estado.id == 2 &&
            this.rol == "ROLE_ADMIN" &&
            new Date() > new Date(item.fecha_informe),
        },
        {
          name: "imprimirLiquidacion",
          icon: "local_printshop",
          color: "secondary",
          label: "Imprimir Liquidación",
          event: "imprimirLiquidacion",
          show: (item) => item.estado_estado.id == 4,
        },
        {
          name: "descargarInforme",
          icon: "picture_as_pdf",
          color: "info",
          label: "Descargar Informe",
          event: "descargarInforme",
          show: (item) =>
            item.estado_estado.id == 3 || item.estado_estado.id == 4,
        },
        {
          name: "rechazar",
          icon: "clear",
          color: "error",
          label: "Rechazar Informe",
          event: "rechazar",
          show: (item) => item.estado_estado.id == 3,
        },
      ],
    };
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nuevo Registro" : "Editar Registro";
    },
    formTitle2() {
      return this.editedIndex2 === -1
        ? "Asignación de Presupuesto"
        : "Editar Asignación de Presupuesto";
    },
    formTitle3() {
      return this.editedIndex3 === -1
        ? "Registrar Liquidacion"
        : "Editar Asignacion de Liquidacion";
    },
    isAdmin() {
      return (
        this.$store.state.user && this.$store.state.user.rol == "ROLE_ADMIN"
      );
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialog2(val) {
      val || this.presupClose();
    },
    dialgo3(val) {
      val || this.close1();
    },
  },
  created() {
    this.initialize();
    //this.liquidacionList();
  },
  methods: {
    async initialize() {
      try {
        const token = this.$store.state.token;
        this.pais = (await getPaises(token)).data.map((item) => ({
          text: item.nombre,
          value: item.id,
        }));
        this.departamentos = (await getDepartamentos(token)).data.map(
          (item) => ({ text: item.departamento, value: item.id }),
        );
        this.transporte = (await getTransporte(token)).data.map((item) => ({
          text: item.nombre,
          value: item.id,
        }));
        this.unidad = (await getUnidad(token)).data.map((item) => ({
          text: item.descripcion,
          value: item.id,
        }));
        this.financiamientos = (await getFinanciamiento(token)).data.map(
          (item) => ({ text: item.nombre, value: item.id }),
        );
        this.rn = (await getRegionNacional(token)).data.map((item) => ({
          text: item.nombre,
          value: item.id,
        }));
        this.ri = (await getRegionInternacional(token)).data.map((item) => ({
          text: item.nombre,
          value: item.id,
        }));
        this.linea = (await getLineaAerea(token)).data.map((item) => ({
          text: item.nombre,
          value: item.id,
        }));
        this.resolucion = (await getResolucion(token)).data.map((item) => ({
          text: item.descripcion,
          value: item.id,
        }));
        await this.viajeList();
      } catch (error) {
        this.message = "Error al inicializar datos";
        this.color = "error";
        this.snackbar = true;
      }
    },
    async viajeList() {
      try {
        const token = this.$store.state.token;
        this.rol = this.$store.state.user.rol;
        const userId = this.$store.state.user._id;
        const userData = (await getUsuario(userId, token)).data;
        let unidad;
        if (this.rol == "ROLE_ADMIN") {
          this.unidadModel = 1;
          await this.changeUnidad(1);
        } else {
          unidad = userData.unidad;
          const response = await getViajesPorUnidad(unidad, token);
          this.viaje = response.data;
          this.viaje.forEach((element) => {
            let tpasaje = 0;
            element.pasajes.forEach((item) => {
              tpasaje += item.total;
            });
            element.tpasaje = tpasaje;
            element.fecha1 =
              new Date(element.fecha1).toLocaleDateString("en-GB") +
              " " +
              new Date(element.fecha1).toLocaleTimeString("en-GB", {
                hour: "2-digit",
                minute: "2-digit",
              });
            element.fecha2 =
              new Date(element.fecha2).toLocaleDateString("en-GB") +
              " " +
              new Date(element.fecha2).toLocaleTimeString("en-GB", {
                hour: "2-digit",
                minute: "2-digit",
              });
            element.fecha_informe = new Date(
              element.fecha_informe,
            ).toLocaleDateString("en-GB");
            let regex = /(\d+)/g;
            element.nro =
              element.cite.match(regex)[0] + "-" + element.cite.match(regex)[1];
            if (element.viaje_internacionals.length > 0) {
              element.total_viatico = element.total_viatico * 6.97;
            }
            if (element.pasajes.length > 0) {
              element.pasajes.forEach((item) => {
                item.expanded = element.estado == 2;
              });
            }
          });
        }
      } catch (error) {
        this.message = "Error al cargar viajes";
        this.color = "error";
        this.snackbar = true;
        this.viaje = [];
      }
    },
    async changeUnidad(valor) {
      try {
        const token = this.$store.state.token;
        const response = await getViajesPorUnidad(valor, token);
        this.viaje = response.data;
        this.viaje.forEach((element) => {
          let tpasaje = 0;
          element.pasajes.forEach((item) => {
            tpasaje += item.total;
          });
          element.tpasaje = tpasaje;
          element.fecha1 =
            new Date(element.fecha1).toLocaleDateString("en-GB") +
            " " +
            new Date(element.fecha1).toLocaleTimeString("en-GB", {
              hour: "2-digit",
              minute: "2-digit",
            });
          element.fecha2 =
            new Date(element.fecha2).toLocaleDateString("en-GB") +
            " " +
            new Date(element.fecha2).toLocaleTimeString("en-GB", {
              hour: "2-digit",
              minute: "2-digit",
            });
          element.fecha_informe =
            new Date(element.fecha_informe).toLocaleDateString("en-GB") +
            " " +
            new Date(element.fecha_informe).toLocaleTimeString("en-GB", {
              hour: "2-digit",
              minute: "2-digit",
            });
          let regex = /(\d+)/g;
          element.nro =
            element.cite.match(regex)[0] + "-" + element.cite.match(regex)[1];
          if (element.viaje_internacionals.length > 0) {
            element.total_viatico = element.total_viatico * 6.97;
          }
          if (element.pasajes.length > 0) {
            element.pasajes.forEach((item) => {
              item.expanded = element.estado == 2;
            });
          }
        });
      } catch (error) {
        this.message = "Error al cambiar unidad";
        this.color = "error";
        this.snackbar = true;
        this.viaje = [];
      }
    },
    async changeState2(valor) {
      try {
        const token = this.$store.state.token;
        const userId = this.$store.state.user._id;
        const data = (await getUsuario(userId, token)).data;
        const o = data.departamento_trabajo_departamento.nombre;
        this.editedItem.ruta_viaje = o + " - " + valor + " - " + o;
      } catch (error) {
        this.message = "Error al obtener departamento de trabajo";
        this.color = "error";
        this.snackbar = true;
      }
    },
    async bajarPDF(item) {
      try {
        console.log(item);
        this.titlePDF = `Informe de Viaje ${item.cite}`;
        const token = this.$store.state.token;
        const response = await downloadArchivo(item.id, token);
        // Convertir base64 a blob
        const byteCharacters = atob(response.data.archivo);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: "application/pdf" });
        // Crear URL del blob
        this.pdfUrl = URL.createObjectURL(blob);
        this.pdfDialog = true;
      } catch (error) {
        this.message = "Error al descargar archivo";
        this.color = "error";
        this.snackbar = true;
      }
    },
    printPdf() {
      const iframe = document.createElement("iframe");
      iframe.style.display = "none";
      iframe.src = this.pdfUrl;
      document.body.appendChild(iframe);
      iframe.onload = function () {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
        document.body.removeChild(iframe);
      };
    },
    downloadPdf() {
      const link = document.createElement("a");
      link.href = this.pdfUrl;
      link.download = "informe.pdf";
      link.click();
    },
    closePdfDialog() {
      if (this.pdfUrl) {
        URL.revokeObjectURL(this.pdfUrl);
        this.pdfUrl = "";
        this.titlePDF = "";
      }
      this.pdfDialog = false;
    },
    async cancelViajeConfirm() {
      try {
        const token = this.$store.state.token;
        if (this.editedItem2.estado == 1 || this.editedItem2.estado == 2) {
          await this.$api.cancelarViaje(
            this.editedItem2.id,
            {
              userupdate: this.$store.state.user._id,
              idunidad: this.editedItem2.idunidad,
              total_viatico: this.editedItem2.total_viatico,
              obs: this.motivo,
              estado: 5,
            },
            token,
          );
          this.message = "Viaje anulado correctamente";
          this.color = "success";
          this.snackbar = true;
          this.motivo = "";
          this.viajeList();
          this.closeCancelViaje();
        } else {
          this.message = "Ocurrió un error";
          this.color = "error";
          this.snackbar = true;
          this.viajeList();
          this.closeCancelViaje();
        }
      } catch (error) {
        this.message = "Ocurrió un error al anular el viaje";
        this.color = "error";
        this.snackbar = true;
        this.viajeList();
        this.closeCancelViaje();
      }
    },
    async changeEdit(item) {
      try {
        const token = this.$store.state.token;
        let fecha = new Date();
        fecha.setMinutes(fecha.getMinutes() + 15);
        await updateViaje(item.id, { actual: fecha }, token);
        this.viajeList();
        this.message = "Edición habilitada correctamente";
        this.color = "success";
        this.snackbar = true;
      } catch (error) {
        this.message = "Error al habilitar edición";
        this.color = "error";
        this.snackbar = true;
        this.viajeList();
      }
    },
    camFecha(item) {
      this.solPdf = item;
      console.log(this.solPdf);
      this.dialog4 = true;
    },
    closeCamFecha() {
      this.solPdf = {};
      this.dialog4 = false;
    },
    editItem(item) {
      /* if (item.pais == 187) {
        this.showLugar = true;
      } else {
        this.showLugar = false;
      } */
      if (item.distancia == 1) {
        this.editedItem.distancia = true;
      } else {
        this.editedItem.distancia = false;
      }
      if (this.$store.state.user.rol == "ROLE_ADMIN")
        this.editedItem.date = new Date(
          item.fecha1.split(" ")[0].split("/").reverse().join("-"),
        ).setDate(1);
      else
        this.editedItem.date = new Date(
          item.fecha1.split(" ")[0].split("/").reverse().join("-"),
        )
          .toISOString()
          .substring(0, 10);
      this.editedIndex = this.viaje.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.editedItem.date = new Date(
        item.fecha1.split(" ")[0].split("/").reverse().join("-"),
      )
        .toISOString()
        .substring(0, 10);
      this.editedItem.time = item.fecha1.split(" ")[1];
      this.editedItem.date2 = new Date(
        item.fecha2.split(" ")[0].split("/").reverse().join("-"),
      )
        .toISOString()
        .substring(0, 10);
      this.editedItem.time2 = item.fecha2.split(" ")[1];
      this.editedItem.radioRow = item.excepcion;
      this.editedItem.radioPoa = item.poa;
      if (item.viaje_internacionals.length > 0) {
        this.editedItem.tv = item.viaje_internacionals[0].region_internacional;
      } else {
        this.editedItem.tv = item.viaje_nacionals[0].region_nacional;
        if (item.viaje_nacionals[0].region_nacional == 2) {
          this.showCheck = true;
        }
      }
      this.dialog = true;
    },

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    /* liquidacionList() {
      let aux = this;
      axios
        .get("liquidacion/list")
        .then((response) => {
          aux.pasaje = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    }, */
    editItem1(item) {
      //this.editedIndex3 = this.liquidacion.indexOf(item);
      this.editedItem3.paisComision = item.pais;
      this.editedItem3.lugarli = item.lugar;
      if (item.viaje_nacionals.length > 0) {
        this.editedItem3.tvLi =
          item.viaje_nacionals[0].region_nacional_region_nacional.nombre;
        this.editedItem3.iddeptoComision =
          item.iddepto_departamento.departamento;
      } else {
        this.editedItem3.tvLi =
          item.viaje_internacionals[0].region_internacional_region_internacional.nombre;
      }
      this.editedItem3.motivoViaje = item.motivo;
      this.editedItem3.ruta_viajeLi = item.ruta_viaje;
      this.editedItem3.resolucionLi = item.resolucion;
      this.editedItem3.idunidadLi = item.idunidad;
      this.editedItem3.transporteLi = item.transporte;
      this.editedItem3.facturacion = item.facturacion;
      this.editedItem3.distanciaLi = item.distancia;
      this.editedItem3.financiamientoLi = item.financiamiento;
      this.editedItem3.fecha1li = item.fecha1;
      this.editedItem3.fecha2li = item.fecha2;
      let montoAereo = 0;
      let montoTerr = 0;
      item.pasajes.map((element) => {
        if (element.pas_aereo > 0) {
          montoAereo += element.total;
        }
        if (element.pas_terrestre > 0) {
          montoTerr += element.total;
        }
      });
      this.editedItem3.anticipo = item.anticipo;
      this.editedItem3.pasAereoLi = montoAereo;
      this.editedItem3.pasTerrestreLi = montoTerr;
      /* this.editedItem3.pasAereoLides =
        item.pasajes[0].pas_aereo - item.pasajes[0].pas_aereo * 0.155;
      this.editedItem3.pasTerrestreLides =
        item.pasajes[0].pas_terrestre - item.pasajes[0].pas_terrestre * 0.155; */
      /* this.editedItem3.boletosLi = item.boletos;
      this.editedItem3.facturacion = item.facturacion; */
      this.editedItem3.idviaje = item.id;
      this.editedItem3.idpasajes = item.id;
      this.dialog3 = true;
    },
    close1() {
      this.dialog3 = false;
      this.$nextTick(() => {
        this.viajeList();
        this.editedItem3 = Object.assign({}, this.defaultItem3);
        this.editedIndex3 = -1;
        this.select = Object.assign({}, this.defaultItem3);
        this.showterrestre = false;
        this.showaereo = false;
      });
      this.$refs.form3.reset();
    },
    convString(cad) {
      let palabras = cad.split(" ").map((palabra) => {
        return palabra[0].toUpperCase() + palabra.slice(1).toLowerCase();
      });
      return palabras.join(" ");
    },
    save1() {
      let verif = this.$refs.form3.validate();
      if (verif) {
        let aux = this;
        let header = { Token: this.$store.state.token };
        let conf = { headers: header };
        !this.editedItem3.observaciones
          ? ""
          : this.editedItem3.observaciones.toUpperCase().trim();
        axios
          .post(
            "liquidacion/add",
            {
              num_factura: this.editedItem3.num_factura,
              idfinanciamiento: this.editedItem3.financiamientoLi,
              idunidad: this.editedItem3.idunidadLi,
              idresolucion: this.editedItem3.resolucionLi,
              idtransporte: this.editedItem3.transporteLi,
              observaciones: this.editedItem3.observaciones,
              //reembolso: this.editedItem3.reembolso,
              facturacion: this.editedItem3.facturacion,
              viaje: this.editedItem3.idviaje,
              estado: 4,
              idviaje: this.editedItem3.idviaje,
              userupdate: this.$store.state.user._id,
              usercreate: this.$store.state.user._id,
              num_facturaaereo: this.editedItem3.num_facturaaereo,
              num_facturaterres: this.editedItem3.num_facturaterres,
              facturacionaereo: "reembolso", //this.editedItem3.facturacionaereo
              facturacionterres: "reembolso", //this.editedItem3.facturacionterres||
              anticipo: this.editedItem3.anticipo + "",
            },
            conf,
          )
          .then((data) => {
            console.log(data.data);
            this.message = data.data.message;
            this.message = "DATOS REGISTRADOS";
            this.color = "success";
            this.snackbar = true;
            this.close1();
            this.viajeList();
          })
          .catch((error) => {
            console.log(error);
          });
        this.close1();
      }
    },
    changetipote(valor) {
      this.editedItem3.pasTerrestreLi = 0;
      valor != "anticipo"
        ? (this.showterrestre = true)
        : (this.showterrestre = false);
    },
    changetipoae(valor) {
      this.editedItem3.pasAereoLi = 0;
      valor != "anticipo" ? (this.showaereo = true) : (this.showaereo = false);
    },

    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.editedItem.date = new Date(
          Date.now() - new Date().getTimezoneOffset() * 60000,
        )
          .toISOString()
          .substring(0, 10);
        this.editedItem.time = null;
        this.editedItem.date2 = null;
        this.editedItem.time2 = null;
        this.showLugar = false;
        this.showCheck = false;
        //this.showfacte = false;
      });
      this.$refs.form.reset();
    },
    save() {
      let verif = this.$refs.form.validate();
      let fecha1 = new Date(this.editedItem.date + " " + this.editedItem.time);
      let fecha2 = new Date(
        this.editedItem.date2 + " " + this.editedItem.time2,
      );
      if (this.editedItem)
        if (verif) {
          let dias = this.calcuDays(
            new Date(this.editedItem.date2 + " " + this.editedItem.time2),
            new Date(this.editedItem.date + " " + this.editedItem.time),
            this.editedItem.resolucion,
            this.editedItem.tv,
          );
          this.editedItem.fecha1 =
            this.editedItem.date + " " + this.editedItem.time;
          this.editedItem.fecha2 =
            this.editedItem.date2 + " " + this.editedItem.time2;
          this.editedItem.motivo = this.editedItem.motivo.toUpperCase();
          this.editedItem.lugar = this.editedItem.lugar.toUpperCase();
          this.editedItem.ruta_viaje = this.editedItem.ruta_viaje.toUpperCase();
          let informe = this.fechaEntrega(
            new Date(this.editedItem.date2 + " " + this.editedItem.time2),
          );
          let region = this.editedItem.tv;
          let header = { Token: this.$store.state.token };
          let conf = { headers: header };
          if (this.editedIndex > -1) {
            axios
              .put(
                "viaje/update/" + this.editedItem.id,
                {
                  estado: this.editedItem.estado,
                  comisionado: this.editedItem.comisionado,
                  pais: this.editedItem.pais,
                  ruta_viaje: this.editedItem.ruta_viaje,
                  lugar: this.editedItem.lugar,
                  transporte: this.editedItem.transporte,
                  financiamiento: this.editedItem.financiamiento,
                  fecha1: this.editedItem.fecha1,
                  fecha2: this.editedItem.fecha2,
                  dias: dias,
                  total_viatico: this.editedItem.total_viatico,
                  resolucion: this.editedItem.resolucion,
                  //fuente_financiamiento: ,
                  motivo: this.editedItem.motivo.trim(),
                  //unidad: this.editedItem.unidad,
                  slug: this.editedItem.slug,
                  cite: this.editedItem.cite,
                  representacion: this.editedItem.representacion,
                  viatico: this.editedItem.viatico,
                  fines_semana: this.editedItem.fines_semana,
                  //fecha_modificacion: ,
                  cot_dolar: this.editedItem.cot_dolar,
                  iva: this.editedItem.iva,
                  anticipo: this.editedItem.anticipo,
                  fecha_informe: informe,
                  //fecha_reliquidado: ,
                  //fecha_creacion: ,
                  //idpresupuesto: ,
                  idunidad: this.editedItem.idunidad,
                  iddepto: this.editedItem.iddepto,
                  userupdate: this.$store.state.user._id,
                  distancia: this.editedItem.distancia,
                  region: region,
                  inter: this.showLugar,
                  excepcion: this.editedItem.radioRow,
                  poa: this.editedItem.radioPoa,
                },
                conf,
              )
              .then((data) => {
                this.message = data.data.message;
                this.color = "success";
                this.snackbar = true;
                this.close();
                this.viajeList();
              })
              .catch((error) => {
                console.log(error);
              });
          } else {
            axios
              .post(
                "viaje/add",
                {
                  //comisionado: ,
                  pais: this.editedItem.pais,
                  ruta_viaje: this.editedItem.ruta_viaje,
                  lugar: this.editedItem.lugar.trim(),
                  transporte: this.editedItem.transporte,
                  financiamiento: this.editedItem.financiamiento,
                  fecha1: this.editedItem.fecha1,
                  fecha2: this.editedItem.fecha2,
                  dias: dias,
                  total_viatico: 0,
                  resolucion: this.editedItem.resolucion,
                  //fuente_financiamiento: ,
                  motivo: this.editedItem.motivo.trim(),
                  //unidad: this.editedItem.unidad,
                  slug: "prueba",
                  cite: "",
                  estado: 1,
                  representacion: 0,
                  viatico: 0,
                  fines_semana: "1",
                  //fecha_modificacion: ,
                  cot_dolar: 6.97,
                  iva: "s",
                  anticipo: "No",
                  fecha_informe: informe,
                  //fecha_reliquidado: ,
                  //fecha_creacion: ,
                  //idpresupuesto: ,
                  idunidad: this.editedItem.idunidad,
                  iddepto: this.editedItem.iddepto,
                  usercreate: this.$store.state.user._id,
                  distancia: this.editedItem.distancia,
                  region: region,
                  inter: this.showLugar,
                  excepcion: this.editedItem.radioRow,
                  poa: this.editedItem.radioPoa,
                },
                conf,
              )
              .then((data) => {
                this.message = data.data.message;
                this.color = "success";
                this.snackbar = true;
                this.close();
                this.viajeList();
              })
              .catch((error) => {
                console.log(error);
              });
          }
          this.close();
        }
    },
    // calcuDays(fecha1, fecha2, resolucion, tv) {
    //   let f1 = new Date(`
    //     ${fecha1.getMonth() + 1}/
    //     ${fecha1.getDate()}/${fecha1.getFullYear()}
    //   `);
    //   let f2 = new Date(`
    //     ${fecha2.getMonth() + 1}/
    //     ${fecha2.getDate()}/
    //     ${fecha2.getFullYear()}
    //   `);
    //   //console.log((f1 - f2) / (1000 * 60 * 60 * 24));
    //   //console.log((((fecha1 - fecha2) / (1000 * 60 * 60 * 24)) * 10) / 10);
    //   let d = (f1 - f2) / (1000 * 60 * 60 * 24) + 1;
    //   console.log(d);
    //   /* if (Math.floor(d) != 0) {
    //     if (Number.parseFloat(d)) {
    //       if (d - Math.floor(d) > 0.5) d = Math.round(d);
    //       else if (Math.round(d) == 0) d = Math.round(d) + 1;
    //       else d = Math.round(d);
    //     }
    //   } */
    //   //console.log(d);
    //   let c = 0;
    //   while (fecha2.getTime() <= fecha1.getTime()) {
    //     //console.log(fecha2.getTime());
    //     if (resolucion != 3) {
    //       if (fecha2.getDay() == 0 || fecha2.getDay() == 6) {
    //         c += 1;
    //       }
    //     }
    //     fecha2.setDate(fecha2.getDate() + 1);
    //   }
    //   d = d - c;
    //   //console.log(d, c);

    //   if (d < 1 && d >= 0) {
    //     d = 1;
    //   } else if (tv == 1) {
    //     if (fecha1.getHours() == 13 && fecha1.getMinutes() == 0 && c == 0) {
    //       d = d - 1;
    //     } else if (
    //       fecha1.getHours() >= 13 &&
    //       fecha1.getMinutes() >= 0 &&
    //       fecha1.getHours() < 19 &&
    //       c == 0
    //     ) {
    //       d = d - 0.5;
    //     } else if (
    //       fecha1.getHours() == 19 &&
    //       fecha1.getMinutes() == 0 &&
    //       c == 0
    //     ) {
    //       d = d - 0.5;
    //     } else if (fecha1.getHours() < 13 && c == 0) {
    //       //console.log(d);
    //       d = d - 1;
    //     }
    //     if (d < 1) d = 1;
    //   } else {
    //     //console.log(d, fecha1.getHours(), fecha1.getMinutes());
    //     if (fecha1.getHours() >= 13 && d > 1) {
    //       if (fecha1.getHours() == 13 && fecha1.getMinutes() == 0) d = d - 1;
    //       else d = d - 0.5;
    //     } else {
    //       d = d - 1;
    //     }
    //     if (d == 0) d = 1;
    //   }
    //   console.log(d);
    //   return d;
    // },

    calcuDays(fecha1, fecha2, resolucion, tv) {
      let f1 = new Date(`
        ${fecha1.getMonth() + 1}/
        ${fecha1.getDate()}/${fecha1.getFullYear()}
      `);
      let f2 = new Date(`
        ${fecha2.getMonth() + 1}/
        ${fecha2.getDate()}/${fecha2.getFullYear()}
      `);
      let d = (f1 - f2) / (1000 * 60 * 60 * 24) + 1;
      console.log(d);
      let c = 0;
      while (fecha2.getTime() <= fecha1.getTime()) {
        //console.log(fecha2.getTime());
        if (resolucion != 3) {
          if (fecha2.getDay() == 0 || fecha2.getDay() == 6) {
            c += 1;
          }
        }
        fecha2.setDate(fecha2.getDate() + 1);
      }
      d = d - c;
      if (d < 1 && d >= 0) {
        d = 1;
      } else if (tv == 1) {
        if (fecha1.getHours() == 13 && fecha1.getMinutes() == 0) {
          d = d - 1;
        } else if (
          fecha1.getHours() >= 13 &&
          fecha1.getMinutes() >= 0 &&
          fecha1.getHours() < 19
        ) {
          d = d - 0.5;
        } else if (fecha1.getHours() == 19 && fecha1.getMinutes() == 0) {
          d = d - 0.5;
        } else if (fecha1.getHours() < 13 && c == 0) {
          d = d - 1;
        }
        if (d < 1) d = 1;
      } else {
        //console.log(d, fecha1.getHours(), fecha1.getMinutes());
        /* if (fecha1.getHours() >= 13 && fecha1.getMinutes() > 0 && d >= 1) {
          d = d - 0.5;
        } else {
          d = d - 1;
        } */
        if (fecha1.getHours() >= 13 && d > 1) {
          if (fecha1.getHours() == 13 && fecha1.getMinutes() == 0) d = d - 1;
          else d = d - 0.5;
        } else {
          if (c == 0) d = d - 1;
        }
        if (d == 0) d = 1;
      }
      return d;
    },
    changeState(valor) {
      if (valor == 187) this.showLugar = true;
      else {
        this.editedItem.lugar = "";
        this.showLugar = false;
      }
    },
    changeTipo(valor) {
      if (valor == 2) this.showCheck = true;
      else {
        this.showCheck = false;
      }
    },
    changeBoleto(valor) {
      let a = this.reuBoleto.find((data) => data.id == valor);
      this.editedItem2.pasAereo = a.pasaje_pasaje.pas_aereo;
      this.editedItem2.lineaAerea = a.linea_aerea;
      this.editedItem2.reBoleto = a.ticket;
      this.editedItem2.tazaAereo = a.pasaje_pasaje.tazaAereo;
      this.editedItem2.pasTerrestre = 0;
    },
    fechaEntrega(fecha) {
      let i = 0;
      do {
        i++;
        fecha.setDate(fecha.getDate() + 1);
        if (fecha.getDay() == 0 || fecha.getDay() == 6) {
          i--;
        }
      } while (i < 8);
      fecha.setHours(23);
      fecha.setMinutes(59);
      return fecha;
    },
    changeRadio() {
      let a = new Date(Date.now() - new Date().getTimezoneOffset() * 60000);
      if (this.editedItem.radioRow == 1) {
        0;
        a.setDate(a.getDate() + 1);
        this.editedItem.date = a.toISOString().substring(0, 10);
      } else {
        this.editedItem.date = a.toISOString().substring(0, 10);
      }
    },
    addboleto() {
      this.editedItem2.boletoAereo.push({
        id: null,
        reBoleto: null,
        lineaAerea: null,
        pasAereo: null,
      });
    },
    removeboleto(index) {
      if (this.editedItem2.boletoAereo.length <= 1)
        alert("Se require un Boleto");
      else {
        this.editedItem2.delboletoAereo = [];
        this.editedItem2.delboletoAereo.push(
          this.editedItem2.boletoAereo[index],
        );
        this.editedItem2.boletoAereo.splice(index, 1);
      }
      //console.log(this.editedItem2.delboletoAereo);
    },
    addPasaje() {
      this.editedItem2.pasajeTerr.push({
        id: null,
        pasaje: null,
        factura: null,
      });
    },
    delPasaje(index) {
      if (this.editedItem2.pasajeTerr.length <= 1)
        alert("Se requiere minimo un Pasaje Terrestre");
      else this.editedItem2.pasajeTerr.splice(index, 1);
    },
    presupEdit(item) {
      this.boletos = [];
      let header = { Token: this.$store.state.token };
      let conf = { headers: header };
      axios
        .get("aereo/query2/" + item.ruta_viaje, conf)
        .then((res) => {
          console.log(res.data);
          this.swBol = true;
          this.reuBoleto = res.data;
          res.data.map((item) => {
            this.boletos.push({ text: item.ticket, value: item.id });
          });
        })
        .catch((e) => {
          this.swBol = false;
        });
      //this.editedItem2 = Object.assign({}, item);
      this.editedItem2.unidad = this.unidad.find(
        (element) => element.value == item.idunidad,
      ).text;
      this.editedItem2.transporte = item.transporte; // <-- Copiar el tipo de transporte del viaje
      axios
        .get("presupuesto/query2/" + item.idunidad, conf)
        .then((response) => {
          this.presupuesto = response.data.data[0];
          this.editedItem2.cite = item.cite;
          this.editedItem2.id = item.id;
          this.editedItem2.periodoIda = item.fecha1;
          this.editedItem2.periodoVuelta = item.fecha2;
          this.editedItem2.viatico = item.dias;
          this.editedItem2.financiamiento = item.total_viatico;
          this.editedItem2.pasaje = this.roundToTwo(
            this.presupuesto.saldo_pasaje,
          );
          this.editedItem2.salViatico = this.roundToTwo(
            this.presupuesto.saldo_viaticos,
          );
          if (item.transporte == 2 && item.pasajes.length == 0) {
            item.pasajes.push({
              aereo: null,
              id: null,
              numero_boleto: "",
              pas_aereo: 0,
              pas_terrestre: 0,
              tazaAereo: null,
              total: 0,
            });
          }
          switch (item.transporte) {
            case 1:
              this.swtr = false;
              this.swtrAereo = true;
              this.editedItem2.pasTerrestre = 0;
              break;
            case 2:
              this.swtr = true;
              this.swtrAereo = false;
              this.editedItem2.reBoleto = "";
              this.editedItem2.pasAereo = 0;
              break;
            case 3:
              this.swtr = false;
              this.swtrAereo = false;
              this.editedItem2.reBoleto = "";
              this.editedItem2.pasAereo = 0;
              this.editedItem2.pasTerrestre = 0;
              break;
            case 4:
              this.swtr = false;
              this.swtrAereo = false;
              this.editedItem2.reBoleto = "";
              this.editedItem2.pasAereo = 0;
              this.editedItem2.pasTerrestre = 0;
              break;
            case 5:
              this.swtr = true;
              this.swtrAereo = true;
              break;
          }
          this.dialog2 = true;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async presupEdit2(item) {
      //console.log(item);
      let viaje = item.id;
      let header = { Token: this.$store.state.token };
      let conf = { headers: header };
      axios
        .get("presupuesto/query2/" + item.idunidad, conf)
        .then(async (response) => {
          this.presupuesto = response.data.data[0];

          if (item.pasajes.length > 0) {
            axios.get("pasaje/query2/" + item.id, conf).then(async (data) => {
              console.log(data);
              this.editedIndex2 = this.viaje.indexOf(item);
              this.editedItem2 = Object.assign({}, item);
              this.editedItem2.unidad = this.unidad.find(
                (element) => element.value == item.idunidad,
              ).text;
              this.editedItem2.id = data.data.id;
              this.editedItem2.periodoIda = item.fecha1;
              this.editedItem2.periodoVuelta = item.fecha2;
              this.editedItem2.viatico = item.dias;
              this.editedItem2.financiamiento = item.total_viatico;
              this.editedItem2.pasaje = this.roundToTwo(
                this.presupuesto.saldo_pasaje,
              );
              this.editedItem2.salViatico = this.roundToTwo(
                this.presupuesto.saldo_viaticos,
              );
              this.editedItem2.boletoAereo = [];
              this.editedItem2.pasajeTerr = [];
              switch (item.transporte) {
                case 1:
                  this.swtr = false;
                  this.swtrAereo = true;
                  this.editedItem2.boletoAereo = [];
                  item.pasajes.forEach((element) => {
                    if (element.pas_aereo > 0) {
                      this.editedItem2.boletoAereo.push({
                        id: element.id,
                        pasAereo: element.pas_aereo,
                        reBoleto: element.numero_boleto,
                        lineaAerea: element.aereo.linea_aerea,
                      });
                    }
                    //this.editedItem2.boletoAereo = [...this.boletos];
                  });
                  /* this.editedItem2.pasAereo = data.data.pas_aereo;
            this.editedItem2.lineaAerea = data.data.aereo.linea_aerea;
            this.editedItem2.reBoleto = data.data.numero_boleto; */
                  break;
                case 2:
                  this.swtr = true;
                  this.swtrAereo = false;
                  item.pasajes.map((element) => {
                    if (element.pas_terrestre >= 0) {
                      this.editedItem2.pasajeTerr.push({
                        id: element.id,
                        pasaje: element.pas_terrestre,
                        factura: element.numero_boleto,
                      });
                    }
                  });
                  //this.editedItem2.pasTerrestre = data.data.pas_terrestre;
                  break;
                case 3:
                  this.swtr = false;
                  this.swtrAereo = false;
                  item.pasajes = [];
                  this.editedItem2.boletoAereo = [];
                  this.editedItem2.pasajeTerr = [];
                  break;
                case 4:
                  this.swtr = true;
                  this.swtrAereo = false;
                  item.pasajes.forEach((element) => {
                    if (element.pas_terrestre > 0 && element.aereo == null) {
                      this.editedItem2.pasajeTerr.push({
                        id: element.id,
                        pasaje: element.pas_terrestre,
                        factura: element.numero_boleto,
                      });
                    }
                  });
                  break;
                case 5:
                  this.swtr = true;
                  this.swtrAereo = true;
                  let aux = item.pasajes.find(
                    (element) =>
                      element.pas_aereo == 0 || element.pas_aereo == null,
                  );
                  let aux2 = item.pasajes.find(
                    (element) =>
                      element.pas_terrestre == 0 ||
                      element.pas_terrestre == null,
                  ); /*
                console.log(aux2, aux);
                if (!aux) this.addboleto();
                if (!aux2) this.addPasaje(); */
                  //console.log(item.pasajes.length);
                  if (item.pasajes.length < 2) {
                    if (item.pasajes[0].aereo != null) {
                      this.addPasaje();
                    } else {
                      this.addboleto();
                    }
                  }
                  item.pasajes.forEach((element) => {
                    if (element.pas_aereo > 0 && element.aereo != null) {
                      this.editedItem2.boletoAereo.push({
                        id: element.id,
                        pasAereo: element.pas_aereo,
                        reBoleto: element.numero_boleto,
                        lineaAerea: element.aereo.linea_aerea,
                      });
                    }
                    if (element.pas_terrestre >= 0 && element.aereo == null) {
                      this.editedItem2.pasajeTerr.push({
                        id: element.id,
                        pasaje: element.pas_terrestre,
                        factura: element.numero_boleto,
                      });
                    }
                  });
                  break;
              }
              //this.editedItem2.boletoAereo = [...aereo];
              //this.editedItem2.pasajeTerr = [...terrestre];
              this.editedItem2.viaje = viaje;
              //console.log(this.editedItem2.boletoAereo);
              //console.log(this.editedItem2.pasajeTerr);

              //console.log(this.editedItem2.pasajeTerr);
              this.dialog2 = true;
              //console.log(this.editedItem2);
              this.editedItem2.aux =
                this.roundToTwo(this.presupuesto.saldo_pasaje) +
                data.data.total;
            });
          } else {
            this.editedIndex2 = this.viaje.indexOf(item);
            this.editedItem2 = Object.assign({}, item);
            this.editedItem2.viaje = viaje;
            this.editedItem2.unidad = this.unidad.find(
              (element) => element.value == item.idunidad,
            ).text;
            this.editedItem2.periodoIda = item.fecha1;
            this.editedItem2.periodoVuelta = item.fecha2;
            this.editedItem2.viatico = item.dias;
            this.editedItem2.financiamiento = item.total_viatico;
            this.editedItem2.pasaje = this.roundToTwo(
              this.presupuesto.saldo_pasaje,
            );
            this.editedItem2.salViatico = this.roundToTwo(
              this.presupuesto.saldo_viaticos,
            );
            this.editedItem2.pasajeTerr = [];
            if (item.transporte == 2 && item.pasajes.length == 0) {
              this.addPasaje();
            }
            if (item.transporte == 5 && item.pasajes.length == 0) {
              this.addPasaje();
            }
            switch (item.transporte) {
              case 1:
                this.swtr = false;
                this.swtrAereo = true;
                break;
              case 2:
                this.swtr = true;
                this.swtrAereo = false;
                break;
              case 3:
                this.swtr = false;
                this.swtrAereo = false;
                break;
              case 4:
                this.swtr = true;
                this.swtrAereo = false;
                break;
              case 5:
                this.swtr = true;
                this.swtrAereo = true;
                break;
            }
            //this.editedItem2.boletoAereo = [...this.boletos];
            //console.log(this.editedItem2);
            this.dialog2 = true;
          }
        });
    },
    presupClose() {
      this.dialog2 = false;
      this.$nextTick(() => {
        this.editedIndex2 = -1;
        this.editedItem2 = Object.assign({}, this.defaultItem2);
        this.editedItem2.boletoAereo = [...this.defaultItem2.boletoAereo];
        this.editedItem2.pasajeTerr = [...this.defaultItem2.pasajeTerr];
        this.swtr = false;
        this.swtrAereo = false;
        this.reuBoleto = null;
        this.swBol = false;
      });
      this.$refs.form2.reset();
    },
    async onSavePresupuesto(item) {
      try {
        console.log(item);
        const token = this.$store.state.token;
        let tipo = "";
        if (this.swtr && this.swtrAereo) tipo = "AEREO - TERRESTRE";
        else if (this.swtr) tipo = "TERRESTRE";
        else if (this.swtrAereo) tipo = "AEREO";
        else tipo = "TERRESTRE";
        console.log(item.boletoAereo);
        console.log(item.pasajeTerr);
        if (
          item.boletoAereo &&
          item.boletoAereo.length > 0 &&
          item.boletoAereo[0].id == null &&
          item.boletoAereo[0].pasAereo < 1
        ) {
          item.boletoAereo = [];
        }
        if (
          item.pasajeTerr &&
          item.pasajeTerr.length > 0 &&
          item.pasajeTerr[0].id == null &&
          item.pasajeTerr[0].pasaje < 1
        ) {
          item.pasajeTerr = [];
        }
        let data = {
          tipo,
          boletoAereo: item.boletoAereo,
          viaje: item.id,
          usercreate: this.$store.state.user._id,
          saldo_pasaje: item.pasaje,
          saldo_viaticos: item.salViatico - item.financiamiento,
          pas_terrestre: item.pasajeTerr,
          presupuesto: this.presupuesto.id,
          auxBoleto: item.auxBoleto,
        };
        console.log(data);
        if (this.editedIndex2 > -1) {
          await updatePresupuesto(
            item.viaje,
            { ...data, userupdate: this.$store.state.user._id },
            token,
          );
        } else {
          await addPresupuesto(data, token);
        }
        this.presupClose();
        this.viajeList();
        this.message = "Presupuesto guardado correctamente";
        this.color = "success";
        this.snackbar = true;
      } catch (error) {
        this.presupClose();
        this.viajeList();
        this.message = "Ocurrió un error al guardar el presupuesto";
        this.color = "error";
        this.snackbar = true;
      } finally {
        this.presupClose();
        this.viajeList();
      }
    },
    roundToTwo(num) {
      return +(Math.round(num + "e+2") + "e-2");
    },
    cancelViaje(item) {
      this.editedIndex2 = this.viaje.indexOf(item);
      this.editedItem2 = Object.assign({}, item);
      this.dialogCancel = true;
    },
    closeCancelViaje() {
      this.dialogCancel = false;
      this.$nextTick(() => {
        this.editedItem2 = Object.assign({}, this.defaultItem2);
        this.editedIndex2 = -1;
        this.select = Object.assign({}, this.defaultItem2);
        this.swBol = false;
      });
    },
    cancelViajeConfirm() {
      let header = { Token: this.$store.state.token };
      let conf = { headers: header };
      if (this.editedItem2.estado == 1 || this.editedItem2.estado == 2) {
        axios
          .put(
            "viaje/updateEstado/" + this.editedItem2.id,
            {
              userupdate: this.$store.state.user._id,
              idunidad: this.editedItem2.idunidad,
              total_viatico: this.editedItem2.total_viatico,
              obs: this.motivo,
              estado: 5,
            },
            conf,
          )
          .then((data) => {
            this.message = data.data.message;
            this.color = "success";
            this.snackbar = true;
            this.motivo = "";
            this.viajeList();
            this.closeCancelViaje();
          })
          .catch((error) => {
            this.message = "Ocurrio Algun Fallo";
            this.color = "error";
            this.snackbar = true;
            this.viajeList();
            this.closeCancelViaje();
          });
      } else {
        this.message = "Ocurrio un error";
        this.color = "error";
        this.snackbar = true;
        this.viajeList();
        this.closeCancelViaje();
      }
    },
    changeEdit(item) {
      let header = { Token: this.$store.state.token };
      let conf = { headers: header };
      let fecha = new Date();
      fecha.setMinutes(fecha.getMinutes() + 15);
      axios
        .put("viaje/updateEdit/" + item.id, { actual: fecha }, conf)
        .then((response) => {
          this.viajeList();
          this.message = response.data.message;
          this.color = "success";
          this.snackbar = true;
        })
        .catch((error) => {
          this.message = error.response.data.message;
          this.color = "error";
          this.snackbar = true;
          this.viajeList();
        });
    },
    listTicket() {
      let header = { Token: this.$store.state.token };
      let conf = { header: header };
      axios.get();
    },
    anular(item) {
      console.log(item);
    },
    liberar(item) {
      console.log(item);
    },
    sumField(key, pasajes) {
      return pasajes.reduce((a, b) => a + (b[key] || 0), 0);
    },
    rechazar(item) {
      let header = { Token: this.$store.state.token };
      let conf = { headers: header };
      axios
        .put(
          "viaje/updateEstado2/" + item.id,
          {
            userupdate: this.$store.state.user._id,
            estado: 2,
          },
          conf,
        )
        .then((data) => {
          this.message = data.data.message;
          this.color = "success";
          this.snackbar = true;
          this.viajeList();
          this.closeCancelViaje();
        })
        .catch((error) => {
          this.message = "Ocurrio Algun Fallo";
          this.color = "error";
          this.snackbar = true;
          this.viajeList();
          this.viajeList();
          this.closeCancelViaje();
        });
    },

    async crearPDF(item) {
      //var fechaActual = new Date().toLocaleDateString();
      let fechaActual = this.date.split("-").reverse().join("/");
      var doc = new jsPDF("p", "mm", "letter");
      /* doc.addFileToVFS("verdana-normal.ttf", verdana);
      doc.addFileToVFS("verdana-bold-bold.ttf", verdanaBold);
      doc.addFont("verdana-normal.ttf", "verdana", "normal");
      doc.addFont("verdana-bold-bold.ttf", "verdana", "bold"); */
      let width = doc.internal.pageSize.getWidth();
      let height = doc.internal.pageSize.getHeight();
      let logoaev = new Image();
      logoaev.src = logo2;
      doc.addImage(logoaev, "JPEG", 0, 0, width, height);
      doc.setFontSize(10);
      doc.setFont("helvetica", "bold");
      doc.setLineWidth(0.1);
      doc.text("AUTORIZACIÓN DE SOLICITUD DE PASAJES Y VIATICOS", 58, 38);
      doc.line(58, 38.5, 155, 38.5);
      doc.setFont("helvetica", "bold");
      doc.setFontSize(8);
      doc.text(fechaActual + " - " + item.cite, 15, 48);
      let nro =
        item.cite.match(/(\d+)/g)[0] + "-" + item.cite.match(/(\d+)/g)[1];
      doc.text("AUTORIZACION DE VIAJE N°.:  " + nro, 145, 48);
      let data = `${item.comisionado_comisionado.usuario_usuario.nombre}||${item.dias}||${fechaActual}||${item.cite}`;
      let qr = await QRCode.toDataURL(data);
      doc.addImage(qr, "JPEG", 181, 23, 20, 20);
      doc.setFontSize(6);
      doc.text("PYV - 001", 187, 43);
      doc.rect(15, 49, 186, 195);
      doc.setDrawColor(0);
      doc.setFillColor(238, 237, 237);
      doc.rect(15.7, 49.6, 184.7, 5, "FD");
      doc.setFontSize(8);
      doc.text("DATOS DEL COMISIONADO", 87, 53);
      doc.setFont("helvetica", "normal");
      doc.setFontSize(8);
      doc.rect(15.7, 55.5, 184.7, 21);
      doc.setFont("helvetica", "bold");
      doc.text("NOMBRE DEL COMISIONADO:", 16.5, 59);
      doc.setFont("helvetica", "normal");
      doc.setFontSize(7);
      doc.text(item.comisionado_comisionado.usuario_usuario.nombre, 60.5, 59);
      doc.setFont("helvetica", "bold");
      doc.setFontSize(8);
      doc.text("C.I.:", 148.5, 59);
      doc.setFontSize(7);
      doc.setFont("helvetica", "normal");
      doc.text(item.comisionado_comisionado.usuario_usuario.ci, 155.5, 59);
      doc.setFont("helvetica", "bold");
      doc.setFontSize(8);
      doc.text("OFICINA:", 16.5, 64);
      doc.setFont("helvetica", "normal");
      doc.setFontSize(7);
      doc.text(
        item.comisionado_comisionado.usuario_usuario.oficina_oficina.nombre,
        60.5,
        64,
      );
      /* doc.setFont("helvetica", "bold");
      doc.setFontSize(8);
      doc.text("CELULAR:", 140.5, 58);
      doc.setFontSize(7);
      doc.setFont("helvetica", "normal");
      doc.text(
        String(item.comisionado_comisionado.usuario_usuario.celular || ""),
        155.5,
        58
      ); */
      doc.setFont("helvetica", "bold");
      doc.setFontSize(8);
      doc.text("CARGO:", 16.5, 69);
      doc.setFont("helvetica", "normal");
      doc.text(item.comisionado_comisionado.usuario_usuario.cargo, 60.5, 69);
      doc.setFont("helvetica", "bold");
      doc.text("CATEGORIA:", 16.5, 74);
      doc.setFont("helvetica", "normal");
      doc.text(
        String(item.comisionado_comisionado.usuario_usuario.categoria),
        60.5,
        74,
      );
      doc.setFont("helvetica", "bold");
      doc.text("MOTIVO:", 16.5, 81);
      var parrafoMotivo = doc.splitTextToSize(item.motivo, 165);
      doc.setFont("helvetica", "normal");
      doc.text(parrafoMotivo, 35.5, 81);
      doc.rect(15.7, 76.5, 184.7, 18);
      doc.setDrawColor(0);
      doc.setFillColor(238, 237, 237);
      doc.rect(15.7, 94.5, 184.7, 5, "FD");
      doc.setFont("helvetica", "bold");
      doc.text("ITINERARIO", 98, 97.6);
      doc.rect(15.7, 99.5, 99.3, 22);
      doc.setFont("helvetica", "bold");
      doc.text("RUTA DE VIAJE:", 16.5, 104);
      doc.setFont("helvetica", "normal");
      var ruta = doc.splitTextToSize(item.ruta_viaje, 65);
      doc.text(ruta, 45.5, 102.5);
      doc.setFont("helvetica", "bold");
      doc.text("PAÍS:", 16.5, 111);
      doc.setFont("helvetica", "normal");
      doc.text(item.pais_pai.nombre.toUpperCase(), 45.5, 111);
      let lugar = doc.splitTextToSize(item.lugar, 65);
      if (item.pais_pai.nombre == "Bolivia") {
        doc.setFont("helvetica", "bold");
        doc.text("DEPARTAMENTO:", 16.5, 114);
        doc.setFont("helvetica", "normal");
        doc.text(
          item.iddepto_departamento.departamento.toUpperCase(),
          45.5,
          114,
        );
        doc.setFont("helvetica", "bold");
        doc.text("LUGAR:", 16.5, 119);
        doc.setFont("helvetica", "normal");
        doc.text(lugar, 45.5, 119);
      } else {
        doc.setFont("helvetica", "bold");
        doc.text("LUGAR:", 16.5, 114);
        doc.setFont("helvetica", "normal");
        doc.text(lugar, 45.5, 114);
      }
      doc.rect(15.7, 121.5, 49.65, 5);
      doc.setFont("helvetica", "bold");
      doc.text("FECHA Y HORA DE SALIDA", 22.7, 124.7);
      doc.setFont("helvetica", "normal");
      doc.text(
        `${item.fecha1.split(" ")[0].replaceAll("/", "-")} ${
          item.fecha1.split(" ")[1]
        }`,
        40.7,
        131.5,
        null,
        null,
        "center",
      );
      doc.rect(65.35, 121.5, 49.65, 5);
      doc.setFont("helvetica", "bold");
      doc.text("FECHA Y HORA DE RETORNO", 69.7, 124.7);
      doc.setFont("helvetica", "normal");
      doc.text(
        `${item.fecha2.split(" ")[0].replaceAll("/", "-")} ${
          item.fecha2.split(" ")[1]
        }`,
        89.7,
        131.5,
        null,
        null,
        "center",
      );
      doc.rect(15.7, 126.5, 49.65, 10);
      doc.rect(65.35, 126.5, 49.65, 10);
      doc.rect(115.1, 99.5, 85.3, 22);
      doc.setFont("helvetica", "bold");
      doc.text("MEDIO DE TRANSPORTE:", 116.2, 104);
      doc.setFont("helvetica", "normal");
      let transporte = doc.splitTextToSize(
        item.transporte_transporte.nombre,
        45,
      );
      doc.text(transporte, 153.2, 104);
      doc.setFont("helvetica", "bold");
      doc.text("TIPO DE VIAJE:", 116.2, 111);
      doc.setFont("helvetica", "normal");
      if (item.viaje_nacionals.length > 0) {
        doc.text(
          item.viaje_nacionals[0].region_nacional_region_nacional.nombre,
          153.2,
          111,
        );
      } else if (item.viaje_internacionals.length > 0) {
        let parrafoTipo = doc.splitTextToSize(
          item.viaje_internacionals[0]
            .region_rectinternacional_region_internacional.nombre,
          50,
        );
        doc.text(parrafoTipo, 153.2, 108.5);
      }
      doc.setFont("helvetica", "bold");
      doc.text("FINANCIAMIENTO:", 116.2, 119);
      doc.setFont("helvetica", "normal");
      doc.text(item.financiamiento_financiamiento.nombre, 153.2, 119);
      doc.rect(115.1, 121.5, 85.3, 15);
      doc.setFont("helvetica", "bold");
      doc.text("TOTAL DIAS:", 116.2, 127);
      doc.setFont("helvetica", "normal");
      doc.text(String(item.dias), 140.2, 127);
      doc.setFont("helvetica", "bold");
      doc.text("RESOLUCION:", 116.2, 132.5);
      doc.setFont("helvetica", "normal");
      let parrafoResolucion = doc.splitTextToSize(
        item.resolucion_resolucion.descripcion,
        60,
      );
      doc.text(parrafoResolucion, 140.2, 132.5);
      doc.setDrawColor(0);
      doc.setFillColor(238, 237, 237);
      doc.rect(15.7, 136.5, 184.7, 5, "FD");
      doc.setFont("helvetica", "bold");
      doc.text("FINANCIAMIENTO", 93, 140);
      doc.rect(15.7, 141.5, 99.3, 7);
      doc.setFont("helvetica", "bold");
      doc.text("PROGRAMA:", 16.5, 145.7);
      doc.setFont("helvetica", "normal");
      let programa = doc.splitTextToSize(
        item.idunidad_unidad.fuente + " - " + item.idunidad_unidad.descripcion,
        80,
      );
      doc.text(programa, 40.5, 144.7);
      doc.setFont("helvetica", "bold");
      doc.text("FUENTE:", 116.2, 145.7);
      doc.setFont("helvetica", "normal");
      doc.text(String(item.idunidad_unidad.fuente), 130.2, 145.7);
      doc.rect(115.1, 141.5, 85.3, 7);
      doc.setFont("helvetica", "bold");
      doc.text("PLAZO DE PRESENTACIÓN DE INFORME: ", 16.5, 152);
      doc.setFont("helvetica", "normal");
      doc.text(
        `${item.fecha_informe.split(" ")[0].replaceAll("/", "-")}`,
        74.5,
        152,
      );
      doc.setFont("helvetica", "normal");
      doc.setFontSize(7);
      doc.text(
        'El incumplimiento dará lugar a la aplicación del Art. 25 del "Reglamento Interno de Pasajes y Viáticos".',
        16.5,
        155.8,
      );
      doc.rect(15.7, 148.5, 184.7, 9);
      doc.rect(15.7, 157.5, 184.7, 9);
      doc.rect(15.7, 166.5, 184.7, 33);
      doc.setFont("helvetica", "bold");
      doc.text("SE ENCUENTRA EN EL POA DEL AREA.:", 18.5, 162.8);
      doc.setDrawColor(0);
      doc.setFillColor(255, 255, 255);
      doc.roundedRect(70, 160.1, 5, 4, 2, 2, "FD");
      doc.setFontSize(6);
      doc.setFont("helvetica", "normal");
      doc.text("Si", 76, 162.8);
      doc.setDrawColor(0);
      doc.setFillColor(255, 255, 255);
      doc.roundedRect(79, 160.1, 5, 4, 2, 2, "FD");
      doc.setFontSize(6);
      doc.setFont("helvetica", "normal");
      doc.text("No", 85, 162.8);
      doc.setFont("helvetica", "bold");
      doc.setFontSize(9);
      if (item.poa == 1) {
        doc.text("X", 71.5, 163.3);
      } else {
        doc.text("X", 80.5, 162.3);
      }
      doc.setFontSize(7);
      doc.setFont("helvetica", "bold");
      doc.text("VIAJES POR.:", 108.5, 162.8);
      doc.setFont("helvetica", "bold");
      doc.setDrawColor(0);
      doc.setFillColor(255, 255, 255);
      doc.roundedRect(125.8, 160.1, 4, 4, 2, 2, "FD");
      doc.setFont("helvetica", "normal");
      doc.setFontSize(6);
      doc.text("Excepción - (ART. 14 RPV)", 130.5, 162.8);
      doc.setDrawColor(0);
      doc.setFillColor(255, 255, 255);
      doc.roundedRect(157.5, 160.1, 4, 4, 2, 2, "FD");
      doc.setFont("helvetica", "normal");
      doc.setFontSize(6);
      doc.text("Extraordinario - (Instrucción MAE)", 162.5, 162.8);
      doc.setFont("helvetica", "bold");
      doc.setFontSize(9);
      if (item.excepcion == 2) {
        doc.text("X", 126.8, 163.3);
      } else if (item.excepcion == 3) {
        doc.text("X", 158.5, 163.3);
      }
      doc.setFont("helvetica", "bold");
      doc.setFontSize(7);
      doc.text("SE DEBE TOMAR EN CUENTA QUE:", 16.5, 173.7);
      doc.line(16.5, 171.3, 58.8, 171.3);
      doc.setFont("helvetica", "normal");
      doc.setFontSize(6);
      doc.text(
        "1.- Este formulario debe presentarse debidamente firmado por el comisionado y por la autoridad que aprueba el viaje en los plazos establecidos en el Reglamento de Pasajes y Viáticos.",
        18.5,
        176.5,
      );
      doc.text(
        "2.- Para la suspensión de un viaje, se deberá presentar una nota de justificación con un plazo no menor a las 24 horas antes del viaje, salvo excepciones.",
        18.5,
        178.7,
      );
      doc.setFontSize(7);
      doc.setFont("helvetica", "bold");
      doc.line(16.5, 184.3, 37, 184.3);
      doc.text("ACLARACIONES", 16.5, 183.7);
      doc.setFont("helvetica", "normal");
      doc.setFontSize(6);
      let parrafoAclaracion = doc.splitTextToSize(
        "En los viajes INTERDEPARTAMENTALES, cuando el retorno de una comisión que incluya pernocte, sea efectuado entre horas 13:00 y 19:00 corresponderá el pago al equivalente del 50% de un día de viático por el día de retorno y, el 100% de un día viático, cuando el retorno sea realizado con posterioridad a las 19:00 horas, considerando la hora señalada en el pasaje terrestre o pase abordo, según corresponda, conforme al Reglamento de Pasajes y Viaticos, Artículo 31.\nCuando los viajes sean de carácter INTRADEPARTAMENTAL y la distancia del viaje sea menor a 100 kilómetros de la sede de funciones del comisionado, se pagará un estipendio de Bs. 50; Cuando esta distancia sea mayor a los 100 km se pagará el equivalente al 40% de un día de viático de acuerdo a escala establecida en el presente Reglamento.",
        180,
      );
      doc.text(parrafoAclaracion, 17.5, 187.7);
      doc.rect(15.7, 180.5, 184.7, 62.8);
      let comisionado = doc.splitTextToSize(
        item.comisionado_comisionado.usuario_usuario.nombre +
          "\n" +
          item.comisionado_comisionado.usuario_usuario.cargo,
        60,
      );
      doc.setFont("helvetica", "italic");
      doc.setFontSize(8);
      doc.line(35.5, 234, 103.5, 234);
      doc.text(comisionado, 68.5, 237, { align: "center" });
      doc.line(122.5, 234, 190, 234);
      doc.text("FIRMA Y SELLO DE APROBACION", 155.5, 237, { align: "center" });
      /* doc.setFont("helvetica", "italic");
      doc.setFontSize(5);
      doc.text("PAGINA 1 - SOLICITUD DE VIAJE", 173.5, 260);
      doc.text(
        "Calle Fernando Guachalla No 411 Esq 20 de Octubre - Teléfonos: (591) - 2 - 2147767 - 2148747",
        108.5,
        269,
        { align: "center" }
      );
      doc.line(16, 267, 201, 267); */
      //doc.output("dataurlnewwindow", { filename: "Formulario-Viaje" });
      //doc.save("Formulario-viaje.pdf");
      window.open(doc.output("bloburl", { filename: "Solicitud-Viaje" }));
      this.closeCamFecha();
      //doc.save("Formulario-viaje.pdf");
    },
    async crearPresupPDF(item) {
      //console.log(item);
      let fechaActual = new Date().toLocaleDateString("en-GB");
      let a;
      let monto = 0;
      let montoUnico = 0;
      let montoPas = 0;
      await item.pasajes.map((element) => {
        montoPas = montoPas + element.total;
      });
      if (item.viaje_nacionals.length > 0) {
        a = item.viaje_nacionals[0].region_nacional_region_nacional.nombre;
        if (item.viaje_nacionals[0].region_nacional == 2) {
          if (item.distancia == 1) {
            montoUnico = 50;
          } else {
            if (item.dias == 1)
              montoUnico =
                item.viaje_nacionals[0].region_nacional_region_nacional
                  .cat_ints[0].monto * 0.4;
            else
              montoUnico =
                item.viaje_nacionals[0].region_nacional_region_nacional
                  .cat_ints[0].monto;
          }
        } else {
          montoUnico =
            item.viaje_nacionals[0].region_nacional_region_nacional.cat_ints[0]
              .monto;
        }
        monto = item.total_viatico;
      } else if (item.viaje_internacionals.length > 0) {
        a =
          item.viaje_internacionals[0].region_internacional_region_internacional
            .nombre;
        monto = item.total_viatico * 6.97;
        montoUnico =
          item.viaje_internacionals[0].region_internacional_region_internacional
            .cat_exts[0].monto * 6.97;
      }
      let doc = new jsPDF("p", "mm", "letter");
      let width = doc.internal.pageSize.getWidth();
      let height = doc.internal.pageSize.getHeight();
      let logoaev = new Image();
      logoaev.src = logo2;
      doc.setFont("helvetica", "bold");
      doc.setFontSize(8);
      doc.addImage(logoaev, "JPEG", 0, 0, width, height);
      let data = `${item.comisionado_comisionado.usuario_usuario.nombre}||${item.dias}||${fechaActual}||${item.cite}`;
      let qr = await QRCode.toDataURL(data);
      doc.addImage(qr, "JPEG", 182, 23, 20, 20);
      doc.text("PYV - 003", 185, 44);
      doc.setFontSize(11);
      doc.setFont("helvetica", "bold");
      doc.setLineWidth(0.2);
      let titulo = doc.splitTextToSize(
        "DIRECCIÓN NACIONAL ADMINISTRATIVA FINANCIERA\nPROVISIÓN DE PASAJES Y VIÁTICOS",
      );
      doc.text(titulo, 118, 38, { align: "center" });
      doc.text("CERTIFICACIÓN PRESUPUESTARIA", 83, 142);
      doc.line(83, 142.5, 150.5, 142.5);
      doc.line(67, 38.5, 170, 38.5);
      doc.line(83, 43.2, 153.5, 43.2);
      doc.setFont("helvetica", "normal");
      doc.setFontSize(7);
      doc.text("(Expresado en Bolivianos)", 102, 46);
      doc.setFontSize(11);
      doc.text("FIRMA Y SELLO ENCARGADO DE PASAJE Y VIÁTICOS", 68.5, 133);
      doc.line(66.5, 129.5, 170.5, 129.5);
      doc.text("FIRMA Y SELLO ENCARGADO DE PRESUPUESTO", 74.5, 230);
      doc.line(72.5, 226.5, 167.5, 226.5);
      doc.setFontSize(7);
      doc.text("(Expresado en Bolivianos)", 103.5, 145.5);
      doc.setFont("helvetica", "bold");
      doc.setFontSize(8);
      let nro =
        item.cite.match(/(\d+)/g)[0] + "-" + item.cite.match(/(\d+)/g)[1];
      doc.text("AUTORIZACIÓN DE VIAJE N°: " + nro, 147, 148.5);
      doc.setFont("helvetica", "italic");
      doc.setFontSize(7);
      doc.text(
        "EL ENCARGADO DE PRESUPUESTO CERTIFICA LA EXISTENCIA DE PRESUPUESTO SUFUCIENTE EN LAS PARTIDAS Y FUENTES SEÑALADAS.",
        15,
        182.5,
      );
      //doc.line(16, 254, 202.5, 254);
      //doc.text("PÁGINA 2 - CERTIFICACIÓN PRESUPUESTARIA", 153, 253);

      let table = [
        ["TOTAL DÍAS: ", item.dias],
        [
          "TOTAL POR DÍA: ",
          new Intl.NumberFormat("es-BO", {
            minimumFractionDigits: 2,
          }).format(montoUnico),
        ],
        [
          "TOTAL VIÁTICOS: ",
          new Intl.NumberFormat("es-BO", {
            minimumFractionDigits: 2,
          }).format(monto),
        ],
        [
          "RC - IVA (13%): ",
          new Intl.NumberFormat("es-BO", {
            minimumFractionDigits: 2,
          }).format(0),
        ],
        [
          "TASA AEROPUERTARIA: ",
          new Intl.NumberFormat("es-BO", {
            minimumFractionDigits: 2,
          }).format(0) ||
            new Intl.NumberFormat("es-BO", {
              minimumFractionDigits: 2,
            }).format(0),
        ],
        [
          "TOTAL LIQUIDO PAGABLE VIÁTICO: ",
          {
            content: new Intl.NumberFormat("es-BO", {
              minimumFractionDigits: 2,
            }).format(item.total_viatico),
            styles: { halign: "right", fontStyle: "bold" },
          },
        ],
      ];
      doc.autoTable({
        head: [
          [
            {
              content: "DETALLE DE LA LIQUIDACIÓN DE VIÁTICOS",
              colSpan: 2,
              styles: { halign: "center", color: [255, 255, 255] },
            },
          ],
        ],
        body: table,
        margin: { top: 47, left: 45 },
        columnStyles: { 1: { cellWidth: 65, halign: "right" } },
        tableWidth: 140,
        styles: {
          lineWidth: 0.25,
          lineColor: 0,
          textColor: 50,
          cellPadding: 0.8,
          fontSize: 8,
        },
        headStyles: {
          fillColor: [255, 255, 255],
          fontSize: 9,
        },
        theme: "plain",
      });
      let table2 = [
        [
          "FUENTE",
          "DETALLE",
          "PARTIDA PRESUP.",
          "PRESUP. VIGENTE",
          "EJECUTADO",
          "REQUERIDO",
          "SALDO",
        ],

        [
          item.idunidad_unidad.fuente,
          "PASAJE " + a,
          {
            content: item.idunidad_unidad.presupuestos[0].partida_pas,
            styles: { halign: "right" },
          },
          {
            content: new Intl.NumberFormat("es-BO", {
              minimumFractionDigits: 2,
            }).format(item.idunidad_unidad.presupuestos[0].monto_pre_pasaje),
            styles: { halign: "right" },
          },
          {
            content: new Intl.NumberFormat("es-BO", {
              minimumFractionDigits: 2,
            }).format(
              item.idunidad_unidad.presupuestos[0].monto_pre_pasaje -
                item.idunidad_unidad.presupuestos[0].saldo_pasaje -
                montoPas,
            ),
            styles: { halign: "right" },
          },
          {
            content: new Intl.NumberFormat("es-BO", {
              minimumFractionDigits: 2,
            }).format(montoPas),
            styles: { halign: "right" },
          },
          {
            content:
              new Intl.NumberFormat("es-BO", {
                minimumFractionDigits: 2,
              }).format(item.idunidad_unidad.presupuestos[0].saldo_pasaje) ||
              new Intl.NumberFormat("es-BO", {
                minimumFractionDigits: 2,
              }).format(0),
            styles: { halign: "right" },
          },
        ],
        [
          item.idunidad_unidad.fuente,
          "VIÁTICOS " + a,
          {
            content: item.idunidad_unidad.presupuestos[0].partida_via,
            styles: { halign: "right" },
          },
          {
            content: new Intl.NumberFormat("es-BO", {
              minimumFractionDigits: 2,
            }).format(item.idunidad_unidad.presupuestos[0].monto_pre_viaticos),
            styles: { halign: "right" },
          },
          {
            content: new Intl.NumberFormat("es-BO", {
              minimumFractionDigits: 2,
            }).format(
              item.idunidad_unidad.presupuestos[0].monto_pre_viaticos -
                item.idunidad_unidad.presupuestos[0].saldo_viaticos -
                item.total_viatico,
            ),
            styles: { halign: "right" },
          },
          {
            content: new Intl.NumberFormat("es-BO", {
              minimumFractionDigits: 2,
            }).format(item.total_viatico),
            styles: { halign: "right" },
          },
          {
            content:
              new Intl.NumberFormat("es-BO", {
                minimumFractionDigits: 2,
              }).format(item.idunidad_unidad.presupuestos[0].saldo_viaticos) ||
              new Intl.NumberFormat("es-BO", {
                minimumFractionDigits: 2,
              }).format(0),
            styles: { halign: "right" },
          },
        ],
        [
          {
            content: "TOTAL PASAJES:  ",
            colSpan: 5,
            styles: { halign: "right", fontStyle: "bold" },
          },
          {
            content:
              new Intl.NumberFormat("es-BO", {
                minimumFractionDigits: 2,
              }).format(montoPas) ||
              new Intl.NumberFormat("es-BO", {
                minimumFractionDigits: 2,
              }).format(0),
            colSpan: 2,
            styles: { halign: "center", fontStyle: "bold" },
          },
        ],
        [
          {
            content: "TOTAL VIÄTICOS:  ",
            colSpan: 5,
            styles: { halign: "right", fontStyle: "bold" },
          },
          {
            content: new Intl.NumberFormat("es-BO", {
              minimumFractionDigits: 2,
            }).format(item.total_viatico),
            colSpan: 2,
            styles: { halign: "center", fontStyle: "bold" },
          },
        ],
      ];
      let finalY = doc.lastAutoTable.finalY;
      doc.autoTable({
        startY: finalY + 68,
        head: [
          [
            {
              content: "DETALLE DE LA CERTIFICACIÓN PRESUPUESTARIA",
              colSpan: 7,
              styles: { halign: "center", color: [255, 255, 255] },
            },
          ],
        ],
        body: table2,
        styles: {
          lineWidth: 0.25,
          lineColor: 0,
          textColor: 50,
          cellPadding: 0.8,
          fontSize: 8,
          halign: "center",
        },
        headStyles: {
          fillColor: [255, 255, 255],
          fontSize: 9,
        },
        theme: "plain",
      });
      /* doc.output("dataurlnewwindow", {
        filename: "Certificado-Presupuesto.pdf",
      }); */
      doc.setProperties({
        title: "Certificado de Presupuesto ",
      });
      window.open(doc.output("bloburl", "Certificado_de_Presupuesto.pdf"));
      //doc.output("pdfobjectnewwindow", "Certificado-Presupuesto.pdf");
      //doc.save("Certificado-Presupuesto.pdf");
    },
    async crearLiquiPDF(item) {
      let header = { Token: this.$store.state.token };
      let conf = { header: header };
      let remAereo = 0;
      let antAereo = 0;
      let remTerr = 0;
      let antTerr = 0;
      let antViatico = 0;
      let remViatico = 0;
      await axios.get("liquidacion/query/" + item.id, conf).then((resp) => {
        let calt = 0;
        if (resp.data.facturacionaereo == "reembolso") {
          item.pasajes.map((element) => {
            if (element.aereo) {
              if (element.aereo.linea_aerea != 1)
                remAereo = remAereo + element.pas_aereo;
              else if (
                resp.data.idunidad != 1 &&
                resp.data.idunidad != 11 &&
                resp.data.idunidad != 12
              )
                remAereo = remAereo + element.pas_aereo;
            }
          });
          if (remAereo == 0) {
            remAereo = resp.data.pasaje;
          }
        } else {
          item.pasajes.map((element) => {
            if (element.aereo) {
              if (element.aereo.linea_aerea != 1)
                antAereo = antAereo + element.pas_aereo;
            }
          });
        }
        if (resp.data.facturacionterres == "reembolso") {
          item.pasajes.map((element) => {
            if (element.pas_terrestre > 0) {
              remTerr = remTerr + element.pas_terrestre;
            }
          });
        } else {
          item.pasajes.map((element) => {
            if (element.pas_terrestre > 0) {
              antTerr = antTerr + element.pas_terrestre;
            }
          });
        }
        if (resp.data.viaje_viaje.anticipo == "SI") {
          antViatico = resp.data.viaje_viaje.total_viatico;
        } else {
          remViatico = resp.data.viaje_viaje.total_viatico;
        }
      });
      let fechaActual = new Date().toLocaleDateString("en-GB");
      let nro =
        item.cite.match(/(\d+)/g)[0] + "-" + item.cite.match(/(\d+)/g)[1];
      let montoUnico = 0;
      let montoAd = 0;
      let fecha1 = new Date(
        item.fecha1.split(" ")[0].split("/").reverse().join("-"),
      )
        .toISOString()
        .substring(0, 10)
        .split("-")
        .reverse()
        .join("/");
      let hora1 = item.fecha1.split(" ")[1].substring(0, 5);
      let fecha2 = new Date(
        item.fecha2.split(" ")[0].split("/").reverse().join("-"),
      )
        .toISOString()
        .substring(0, 10)
        .split("-")
        .reverse()
        .join("/");
      let hora2 = item.fecha2.split(" ")[1].substring(0, 5);
      let h = new Date(
        item.fecha2.split(" ")[0].split("/").reverse().join("-") +
          " " +
          item.fecha2.split(" ")[1],
      ).getHours();
      let m = new Date(
        item.fecha2.split(" ")[0].split("/").reverse().join("-") +
          " " +
          item.fecha2.split(" ")[1],
      ).getMinutes();
      if (item.viaje_nacionals.length > 0) {
        if (item.viaje_nacionals[0].region_nacional == 2) {
          if (item.distancia == 1) {
            montoUnico = 50;
            if (item.dias > 1 && h >= 13 && m >= 0) {
              montoAd = montoUnico * 0.5;
            }
          } else {
            if (item.dias == 1)
              montoUnico =
                item.viaje_nacionals[0].region_nacional_region_nacional
                  .cat_ints[0].monto * 0.4;
            else
              montoUnico =
                item.viaje_nacionals[0].region_nacional_region_nacional
                  .cat_ints[0].monto;
            if (item.dias > 1 && h >= 13 && m >= 0) {
              montoAd = montoUnico * 0.5;
            }
          }
        } else {
          montoUnico =
            item.viaje_nacionals[0].region_nacional_region_nacional.cat_ints[0]
              .monto;
          if (item.dias > 1 && h >= 13 && h < 19 && m >= 0) {
            montoAd = montoUnico * 0.5;
          }
        }
      } else if (item.viaje_internacionals.length > 0) {
        monto = item.total_viatico * 6.97;
        montoUnico =
          item.viaje_internacionals[0].region_internacional_region_internacional
            .cat_exts[0].monto * 6.97;
      }
      let res = "SI() NO()";
      if (item.resolucion == 1) {
        res = "SI(X) NO()";
      } else if (item.resolucion == 2) {
        res = "SI() NO(X)";
      }
      let doc = new jsPDF("p", "mm", "letter");
      let width = doc.internal.pageSize.getWidth();
      let height = doc.internal.pageSize.getHeight();
      let logoaev = new Image();
      logoaev.src = logo2;
      doc.addImage(logoaev, "JPEG", 0, 0, width, height);
      let data = `${item.comisionado_comisionado.usuario_usuario.nombre}||${item.dias}||${fechaActual}||${item.cite}`;
      let qr = await QRCode.toDataURL(data);
      doc.setFont("helvetica", "bold");
      doc.setFontSize(8);
      doc.addImage(qr, "JPEG", 182, 23, 20, 20);
      doc.text("PYV - 004", 185, 44);
      //doc.addImage(qr, "JPEG", 182, 9, 20, 20);
      doc.setFontSize(11);
      doc.setFont("helvetica", "bold");
      doc.setLineWidth(0.2);
      let titulo = doc.splitTextToSize(
        "DIRECCIÓN NACIONAL ADMINISTRATIVA FINANCIERA\nPLANILLA DE LIQUIDACIÓN DE VIÁTICOS Y PASAJES",
      );
      doc.text(titulo, 118, 40, { align: "center" });
      doc.line(67, 40.5, 170, 40.5);
      doc.line(67.5, 45.2, 168.8, 45.2);
      doc.setFont("helvetica", "normal");
      doc.setFontSize(7);
      doc.text("(Expresado en Bolivianos)", 118, 48, { align: "center" });

      /* doc.text(
        "PAGINA 1 - 1 - FORMULARIO DE LIQUIDACIÓN DE VIAJE",
        151.5,
        253.1
      ); */
      /* doc.text(
        "Calle Fernando Guachalla No 411 Esq 20 de Octubre - Teléfonos: (591) - 2 - 2147767 - 2148747",
        108.5,
        263,
        { align: "center" }
      );
      doc.line(16, 261, 201, 261); */
      let tipoViaje = "";
      if (item.viaje_nacionals.length > 0) {
        tipoViaje =
          item.viaje_nacionals[0].region_nacional_region_nacional.nombre;
      } else if (item.viaje_internacionals.length > 0) {
        tipoViaje =
          item.viaje_internacionals[0]
            .region_internacional_region_internacional;
      }
      let table = [
        [
          {
            content: "AUTORIZACIÓN N°.:  ",
            styles: { halign: "left", fontStyle: "bold", cellWidth: "wrap" },
          },
          {
            content: nro,
            styles: { halign: "left" },
          },
          {
            content: "COMPLEMENTARIO:  ",
            styles: { halign: "left", fontStyle: "bold" },
          },
          {
            content: "-",
            colSpan: 3,
            styles: { halign: "left", fontStyle: "bold" },
          },
        ],
        [
          {
            content: "NOMBRE:  ",
            styles: { halign: "left", fontStyle: "bold" },
          },
          {
            content: item.comisionado_comisionado.usuario_usuario.nombre,
            styles: { halign: "left" },
          },
          {
            content: "C.I.:  ",
            styles: { halign: "left", fontStyle: "bold" },
          },
          {
            content: item.comisionado_comisionado.usuario_usuario.ci,
            styles: { halign: "left", minCellWidth: 20 },
          },
          {
            content: "CATEGORÍA:  ",
            styles: { halign: "left", fontStyle: "bold" },
          },
          {
            content: item.comisionado_comisionado.categoria,
            styles: { halign: "left" },
          },
        ],
        [
          {
            content: "CARGO: ",
            styles: { halign: "left", fontStyle: "bold" },
          },
          {
            content: item.comisionado_comisionado.usuario_usuario.cargo,
            colSpan: 5,
          },
        ],
        [
          {
            content: "OFICINA: ",
            styles: { halign: "left", fontStyle: "bold" },
          },
          {
            content:
              item.comisionado_comisionado.usuario_usuario.oficina_oficina
                .nombre,
            styles: { halign: "left" },
          },
          {
            content: "RESOLUCIÓN: ",
            styles: { halign: "left", fontStyle: "bold" },
          },
          {
            content: res,
            styles: { halign: "left" },
          },
          {
            content: "TIPO DE VIAJE: ",
            styles: { halign: "left", fontStyle: "bold" },
          },
          {
            content: tipoViaje,
            styles: { halign: "left" },
          },
        ],
        [
          {
            content: "PROGRAMA:",
            styles: { halign: "left", fontStyle: "bold" },
          },
          {
            content: item.idunidad_unidad.descripcion,
          },
          {
            content: "FUENTE:",
            styles: { fontStyle: "bold" },
          },
          {
            content: item.idunidad_unidad.fuente,
            colSpan: 3,
          },
        ],
      ];
      let table2 = [
        [{ content: item.motivo, colSpan: 4, styles: { minCellHeight: 15 } }],
        [
          { content: "RUTA:", styles: { fontStyle: "bold" } },
          { content: item.ruta_viaje, cellWidth: 60 },
          {
            content: "MEDIO DE TRANSPORTE: ",
            styles: { fontStyle: "bold" },
          },
          {
            content: item.transporte_transporte.nombre,
            styles: { minCellWidth: 35 },
          },
        ],
      ];
      let table3 = [
        [
          {
            content: "SALIDA",
            colSpan: 4,
            styles: { halign: "center", fontStyle: "bold" },
          },
          {
            content: "RETORNO",
            colSpan: 4,
            styles: { halign: "center", fontStyle: "bold" },
          },
        ],
        [
          { content: "FECHA: ", styles: { fontStyle: "bold" } },
          { content: fecha1, styles: { halign: "center" } },
          { content: "HORA:", styles: { fontStyle: "bold" } },
          { content: hora1, styles: { halign: "center" } },
          { content: "FECHA: ", styles: { fontStyle: "bold" } },
          { content: fecha2, styles: { halign: "center" } },
          { content: "HORA:", styles: { fontStyle: "bold" } },
          { content: hora2, styles: { halign: "center" } },
        ],
      ];
      //console.log(item.pasajes[0]);
      let terr = 0;
      let aereo = 0;
      for (let i = 0; i < item.pasajes.length; i++) {
        if (item.pasajes[i].aereo) aereo += item.pasajes[i].total;
        else terr += item.pasajes[i].total;
      }
      let table4 = [
        [
          { content: "DÍAS", styles: { halign: "center", fontStyle: "bold" } },
          {
            content: "VIATICO POR DÍA",
            styles: { halign: "center", fontStyle: "bold" },
          },
          {
            content: "% ADICIONAL",
            styles: { halign: "center", fontStyle: "bold" },
          },
          { content: "TOTAL", styles: { halign: "center", fontStyle: "bold" } },
        ],
        [
          { content: item.dias, styles: { halign: "center" } },
          {
            content: new Intl.NumberFormat("es-BO", {
              minimumFractionDigits: 2,
            }).format(montoUnico),
            styles: { halign: "center" },
          },
          {
            content:
              "50% = " +
              new Intl.NumberFormat("es-BO", {
                minimumFractionDigits: 2,
              }).format(montoAd),
            styles: { halign: "center" },
          },
          {
            content: new Intl.NumberFormat("es-BO", {
              minimumFractionDigits: 2,
            }).format(item.total_viatico),
            styles: { halign: "right" },
          },
        ],
        [
          {
            content: "PASAJE TERRESTRE:",
            colSpan: 3,
            styles: { fontStyle: "bold" },
          },
          {
            content:
              new Intl.NumberFormat("es-BO", {
                minimumFractionDigits: 2,
              }).format(terr || 0) ||
              new Intl.NumberFormat("es-BO", {
                minimumFractionDigits: 2,
              }).format(0),
            styles: { halign: "right" },
          },
        ],
        [
          {
            content: "PASAJE AEREO:",
            colSpan: 3,
            styles: { fontStyle: "bold" },
          },
          {
            content:
              new Intl.NumberFormat("es-BO", {
                minimumFractionDigits: 2,
              }).format(aereo || 0) ||
              new Intl.NumberFormat("es-BO", {
                minimumFractionDigits: 2,
              }).format(0),
            styles: { halign: "right" },
          },
        ],
        [
          {
            content: "RETENCIONES RC-IVA (13%):",
            colSpan: 3,
            styles: { fontStyle: "bold" },
          },
          {
            content: new Intl.NumberFormat("es-BO", {
              minimumFractionDigits: 2,
            }).format(0),
            styles: { halign: "right" },
          },
        ],
        [
          {
            content: "TASA AEROPUERTARIA:",
            colSpan: 3,
            styles: { fontStyle: "bold" },
          },
          {
            content:
              new Intl.NumberFormat("es-BO", {
                minimumFractionDigits: 2,
              }).format(item.pasajes[0]?.tazaAereo || 0) ||
              new Intl.NumberFormat("es-BO", {
                minimumFractionDigits: 2,
              }).format(0),
            styles: { halign: "right" },
          },
        ],
        [
          {
            content: "TOTAL PASAJES Y VIÁTICOS:",
            colSpan: 3,
            styles: { fontStyle: "bold" },
          },
          {
            content: new Intl.NumberFormat("es-BO", {
              minimumFractionDigits: 2,
            }).format(terr + aereo + item.total_viatico),
            styles: { fontStyle: "bold", halign: "right" },
          },
        ],
      ];
      let table5 = [
        [
          {
            content: "ANTICIPO",
            colSpan: 2,
            styles: { halign: "center", fontStyle: "bold" },
          },
          {
            content: "REEMBOLSO",
            colSpan: 2,
            styles: { halign: "center", fontStyle: "bold" },
          },
        ],
        [
          { content: "VIÁTICO:", styles: { fontStyle: "bold" } },
          {
            content: new Intl.NumberFormat("es-BO", {
              minimumFractionDigits: 2,
            }).format(antViatico),
            styles: { halign: "right", minCellWidth: 33 },
          },
          { content: "VIÁTICO:", styles: { fontStyle: "bold" } },
          {
            content: new Intl.NumberFormat("es-BO", {
              minimumFractionDigits: 2,
            }).format(remViatico),
            styles: { halign: "right", minCellWidth: 33 },
          },
        ],
        [
          { content: "RC-IVA:", styles: { fontStyle: "bold" } },
          {
            content: new Intl.NumberFormat("es-BO", {
              minimumFractionDigits: 2,
            }).format(0),
            styles: { halign: "right", minCellWidth: 33 },
          },
          { content: "RC-IVA:", styles: { fontStyle: "bold" } },
          {
            content: new Intl.NumberFormat("es-BO", {
              minimumFractionDigits: 2,
            }).format(0),
            styles: { halign: "right", minCellWidth: 33 },
          },
        ],
        [
          { content: "TASA AEROPUERTO", styles: { fontStyle: "bold" } },
          {
            content: new Intl.NumberFormat("es-BO", {
              minimumFractionDigits: 2,
            }).format(0),
            styles: { halign: "right", minCellWidth: 33 },
          },
          { content: "TASA AEROPUERTO", styles: { fontStyle: "bold" } },
          {
            content:
              new Intl.NumberFormat("es-BO", {
                minimumFractionDigits: 2,
              }).format(item.pasajes[0]?.tazaAereo || 0) ||
              new Intl.NumberFormat("es-BO", {
                minimumFractionDigits: 2,
              }).format(0),
            styles: { halign: "right", minCellWidth: 33 },
          },
        ],
        [
          { content: "PASAJE TERRESTRE", styles: { fontStyle: "bold" } },
          {
            content: new Intl.NumberFormat("es-BO", {
              minimumFractionDigits: 2,
            }).format(antTerr),
            styles: { halign: "right", minCellWidth: 33 },
          },
          { content: "PASAJE TERRESTRE", styles: { fontStyle: "bold" } },
          {
            content:
              new Intl.NumberFormat("es-BO", {
                minimumFractionDigits: 2,
              }).format(remTerr) ||
              new Intl.NumberFormat("es-BO", {
                minimumFractionDigits: 2,
              }).format(0),
            styles: { halign: "right", minCellWidth: 33 },
          },
        ],
        [
          { content: "PASAJE AEREO:", styles: { fontStyle: "bold" } },
          {
            content: new Intl.NumberFormat("es-BO", {
              minimumFractionDigits: 2,
            }).format(antAereo),
            styles: { halign: "right", minCellWidth: 33 },
          },
          { content: "PASAJE AEREO:", styles: { fontStyle: "bold" } },
          {
            content:
              new Intl.NumberFormat("es-BO", {
                minimumFractionDigits: 2,
              }).format(remAereo) ||
              new Intl.NumberFormat("es-BO", {
                minimumFractionDigits: 2,
              }).format(0),
            styles: { halign: "right", minCellWidth: 33 },
          },
        ],
        [
          { content: "DEPOSITO CUT:", styles: { fontStyle: "bold" } },
          {
            content: new Intl.NumberFormat("es-BO", {
              minimumFractionDigits: 2,
            }).format(0),
            styles: { halign: "right", minCellWidth: 33 },
          },
          { content: "DEPOSITO CUT:", styles: { fontStyle: "bold" } },
          {
            content: new Intl.NumberFormat("es-BO", {
              minimumFractionDigits: 2,
            }).format(0),
            styles: { halign: "right", minCellWidth: 33 },
          },
        ],
        [
          { content: "TOTAL LIQUIDACIÓN:", styles: { fontStyle: "bold" } },
          {
            content: new Intl.NumberFormat("es-BO", {
              minimumFractionDigits: 2,
            }).format(antAereo + antTerr + antViatico),
            styles: { fontStyle: "bold", halign: "right", minCellWidth: 33 },
          },
          { content: "TOTAL LIQUIDACIÓN:", styles: { fontStyle: "bold" } },
          {
            content: new Intl.NumberFormat("es-BO", {
              minimumFractionDigits: 2,
            }).format(remViatico + remAereo + remTerr),
            styles: { fontStyle: "bold", halign: "right", minCellWidth: 33 },
          },
        ],
      ];
      doc.autoTable({
        head: [
          [
            {
              content: "DATOS DEL COMISIONADO",
              colSpan: 6,
              styles: { halign: "center", color: [255, 255, 255] },
            },
          ],
        ],
        body: table,
        margin: { top: 50 },
        styles: {
          lineWidth: 0.25,
          lineColor: 0,
          textColor: 50,
          cellPadding: 0.8,
          fontSize: 7,
        },
        headStyles: {
          fillColor: [255, 255, 255],
          fontSize: 8,
        },
        theme: "plain",
      });
      doc.autoTable({
        head: [
          [
            {
              content: "OBJETIVO DEL VIAJE",
              colSpan: 4,
              styles: { halign: "center", color: [255, 255, 255] },
            },
          ],
        ],
        body: table2,
        startY: doc.lastAutoTable.finalY,
        styles: {
          lineWidth: 0.25,
          lineColor: 0,
          textColor: 50,
          cellPadding: 0.8,
          fontSize: 7,
        },
        headStyles: {
          fillColor: [255, 255, 255],
          fontSize: 8,
        },
        theme: "plain",
      });
      doc.autoTable({
        head: [
          [
            {
              content: "ITINERARIO",
              colSpan: 8,
              styles: { halign: "center", color: [255, 255, 255] },
            },
          ],
        ],
        body: table3,
        startY: doc.lastAutoTable.finalY,
        styles: {
          lineWidth: 0.25,
          lineColor: 0,
          textColor: 50,
          cellPadding: 0.8,
          fontSize: 7,
        },
        headStyles: {
          fillColor: [255, 255, 255],
          fontSize: 8,
        },
        theme: "plain",
      });
      doc.autoTable({
        head: [
          [
            {
              content: "CALCULO VIÁTICOS",
              colSpan: 4,
              styles: { halign: "center", color: [255, 255, 255] },
            },
          ],
        ],
        body: table4,
        startY: doc.lastAutoTable.finalY,
        styles: {
          lineWidth: 0.25,
          lineColor: 0,
          textColor: 50,
          cellPadding: 0.8,
          fontSize: 7,
        },
        headStyles: {
          fillColor: [255, 255, 255],
          fontSize: 8,
        },
        theme: "plain",
      });
      doc.autoTable({
        head: [
          [
            {
              content: "MONTO ANTICIPÓ - REEMBOLSO",
              colSpan: 4,
              styles: { halign: "center", color: [255, 255, 255] },
            },
          ],
        ],
        body: table5,
        startY: doc.lastAutoTable.finalY,
        styles: {
          lineWidth: 0.25,
          lineColor: 0,
          textColor: 50,
          cellPadding: 0.8,
          fontSize: 7,
        },
        headStyles: {
          fillColor: [255, 255, 255],
          fontSize: 8,
        },
        theme: "plain",
      });
      doc.autoTable({
        head: [
          [
            {
              content: "RECOMENDACIONES",
              styles: { halign: "center", color: [255, 255, 255] },
            },
          ],
        ],
        body: [[{ content: "", styles: { minCellHeight: 15 } }]],
        startY: doc.lastAutoTable.finalY,
        styles: {
          lineWidth: 0.25,
          lineColor: 0,
          textColor: 50,
          cellPadding: 0.8,
          fontSize: 7,
        },
        headStyles: {
          fillColor: [255, 255, 255],
          fontSize: 8,
        },
        theme: "plain",
      });
      let y = doc.lastAutoTable.finalY + 25;
      doc.setDrawColor(0, 0, 0);
      doc.setFontSize(10);
      doc.line(35.5, y, 103.5, y);
      doc.text("ELABORADO Y VERIFICADO", 68.5, y + 4, { align: "center" });
      doc.line(122.5, y, 190, y);
      doc.text("APROBADO", 155.5, y + 4, { align: "center" });
      doc.setFont("helvetica", "italic");
      doc.setFontSize(6);
      doc.setProperties({
        title: "Certificado de Liquidación",
      });
      window.open(doc.output("bloburl", "Certificado_de_Liquidacion.pdf"));
      //doc.output("dataurlnewwindow", { filename: "Certificado-Liquidación" });
      //doc.save("Certificado-Liquidación.pdf");
    },
    async onSaveViaje(item) {
      try {
        const token = this.$store.state.token;
        let dias = this.calcuDays(
          new Date(item.date2 + " " + item.time2),
          new Date(item.date + " " + item.time),
          item.resolucion,
          item.tv,
        );
        item.fecha1 = item.date + " " + item.time;
        item.fecha2 = item.date2 + " " + item.time2;
        item.motivo = item.motivo.toUpperCase();
        item.lugar = item.lugar.toUpperCase();
        item.ruta_viaje = item.ruta_viaje.toUpperCase();
        let informe = this.fechaEntrega(
          new Date(item.date2 + " " + item.time2),
        );
        let region = item.tv;
        let data = {
          pais: item.pais,
          ruta_viaje: item.ruta_viaje,
          lugar: item.lugar.trim(),
          transporte: item.transporte,
          financiamiento: item.financiamiento,
          fecha1: item.fecha1,
          fecha2: item.fecha2,
          dias: dias,
          total_viatico: 0,
          resolucion: item.resolucion,
          motivo: item.motivo.trim(),
          slug: "prueba",
          cite: "",
          estado: 1,
          representacion: 0,
          viatico: 0,
          fines_semana: "1",
          cot_dolar: 6.97,
          iva: "s",
          anticipo: "No",
          fecha_informe: informe,
          idunidad: item.idunidad,
          iddepto: item.iddepto,
          usercreate: this.$store.state.user._id,
          distancia: item.distancia,
          region: region,
          inter: this.showLugar,
          excepcion: item.radioRow,
          poa: item.radioPoa,
        };
        if (this.editedIndex > -1) {
          await updateViaje(
            item.id,
            { ...data, ...item, dias, fecha_informe: informe },
            token,
          );
        } else {
          await addViaje(data, token);
        }
        this.message = "Datos guardados correctamente";
        this.color = "success";
        this.snackbar = true;
        this.close();
        this.viajeList();
      } catch (error) {
        this.message = "Ocurrió un error al guardar el viaje";
        this.color = "error";
        this.snackbar = true;
        this.close();
      }
    },
    async onSaveLiquidacion(item) {
      try {
        const token = this.$store.state.token;
        let data = {
          num_factura: item.num_factura,
          idfinanciamiento: item.financiamientoLi,
          idunidad: item.idunidadLi,
          idresolucion: item.resolucionLi,
          idtransporte: item.transporteLi,
          observaciones: item.observaciones,
          facturacion: item.facturacion,
          viaje: item.idviaje,
          estado: 4,
          idviaje: item.idviaje,
          userupdate: this.$store.state.user._id,
          usercreate: this.$store.state.user._id,
          num_facturaaereo: item.num_facturaaereo,
          num_facturaterres: item.num_facturaterres,
          facturacionaereo: "reembolso",
          facturacionterres: "reembolso",
          pasaje: item.pasAereoLi,
          anticipo: item.anticipo + "",
        };
        await addLiquidacion(data, token);
        this.message = "Liquidación guardada correctamente";
        this.color = "success";
        this.snackbar = true;
        this.close1();
        this.viajeList();
      } catch (error) {
        this.message = "Ocurrió un error al guardar la liquidación";
        this.color = "error";
        this.snackbar = true;
        this.close1();
      }
    },
    handleTableEvent(event, item) {
      switch (event) {
        case "edit":
          this.editItem(item);
          break;
        case "presup":
          this.presupEdit(item);
          break;
        case "imprimir":
          this.camFecha(item);
          break;
        case "presupEdit":
          this.presupEdit2(item);
          break;
        case "liquidar":
          this.editItem1(item);
          break;
        case "cancelar":
          this.cancelViaje(item);
          break;
        case "imprimirPresup":
          this.crearPresupPDF(item);
          break;
        case "habilitarInforme":
          this.changeEdit(item);
          break;
        case "imprimirLiquidacion":
          this.crearLiquiPDF(item);
          break;
        case "descargarInforme":
          this.bajarPDF(item);
          break;
        case "rechazar":
          this.rechazar(item);
          break;
      }
    },
  },
};
</script>
<style scoped>
.inputPrice >>> input[type="number"] {
  -moz-appearance: textfield;
}
.inputPrice >>> input::-webkit-outer-spin-button,
.inputPrice >>> input::-webkit-inner-spin-button {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}
.custom-spacing {
  margin-top: 10px;
  padding-left: 20px;
}
</style>
